{
  "404.message": "다음과 같은 이유로 페이지를 찾을 수 없습니다:",
  "404.message.reason1": "페이지가 존재하지 않습니다.",
  "404.message.reason2": "페이지에 접근할수 있는 권한이 없습니다.",
  "404.nav.dashboard": "대시보드",
  "404.nav.home": "사이트 홈페이지",
  "404.nav.title": "로 이동",
  "404.search.title": "사이트 검색",
  "aboutpage.section.title": "Atlassian Confluence Cloud 그리고 Confluence Cloud 플러그인",
  "accessibility.user.icon": "사용자 아이콘",
  "action.add.comment": "댓글 추가",
  "action.edit.comment": "댓글 편집",
  "action.reorder.pages.sentence": "페이지 순서 변경",
  "action.space.addons": "추가 기능",
  "action.space.overview": "개요",
  "actions.word": "행동",
  "add.comment": "댓글 추가",
  "add.comment.accesskey": "m",
  "add.shortcut": "바로가기 추가",
  "add.word": "추가하기",
  "addlabels.teamlabels": "분류",
  "adf.translation.error.in.render.description.prod": "페이지를 새로 고치고 다시 시도하십시오. 문제가 계속될 경우 <a target=\"_blank\" href=\"{link}\">Atlassian 지원</a>에 문의하시기 바랍니다.",
  "adf.translation.error.in.render.description.staging": "ADF 오류로 인해 콘텐츠를 표시하지 못하고 있습니다. Slack의 <a target=\"_blank\" href=\"{link}\">#cc-content-experience</a> 채널에서도 이 내용을 논의하실 수 있습니다.",
  "adf.translation.error.in.render.title.prod": "콘텐츠를 표시할 수 없습니다.",
  "adf.translation.error.in.render.title.staging": "콘텐츠 표시 중 ADF 오류",
  "adg3.feedback.placeholder": "Confluence의 사용 경험을 공유해 주시면 개선에 대움이 됩니다.",
  "adg3.give.feedback": "의견 보내기",
  "adg3.onboarding.docs.link": "더 알아보기",
  "adg3.onboarding.next": "다음",
  "adg3.onboarding.prev": "이전",
  "adg3.onboarding.sidebar.done": "알겠습니다",
  "adg3.onboarding.skip": "건너뛰기",
  "adg3.onboarding.start": "시작하기",
  "adg3.onboarding.step1.content": "색상, 아이콘과 글꼴을 업데이트하였으므로, 중요 사항을 쉽게 알아볼 수 있고 눈이 전처럼 고생할 필요가 없어졌어요.",
  "adg3.onboarding.step1.title": "새로운 Confluence를 경험해 보세요",
  "adg3.onboarding.step2.content": "검색, 작성과 탐색 등, 가장 필요한 것들이 모두 사이드바에 있습니다.",
  "adg3.onboarding.step2.title": "심플한 사이드바 탐색",
  "adg3.onboarding.step3.content": "하고 있었던 작업이 무엇인지 잊으셨나요? 검색 패널을 통해 최근에 본 페이지의 목록을 볼 수 있습니다.",
  "adg3.onboarding.step3.title": "중단했던 곳으로 다시 돌아가세요",
  "adg3.onboarding.step4.content": "프로필을 통해 피드백을 전달해 개선에 도움을 주세요. 아직 새로운 경험에 대한 준비가 되지 않으셨나요? 그렇다면 프로필에서 이 기능을 끌 수 있습니다.",
  "adg3.onboarding.step4.content.no.optout": "귀하의 의견은 Confluence의 경험을 개선하는 데 큰 역할을 합니다. 더 나은 서비스를 제공해드릴 수 있도록 프로필을 통해 귀하의 생각을 들려주십시오.",
  "adg3.onboarding.step4.title": "최고의 Confluence를 구축하도록 도와 주세요.",
  "adg3.onboarding.user.optin.content": "의견들을 바탕으로 변경 사항을 적용하였으며, 여전히 개선 작업을 진행 중에 있습니다. 추가 의견이 있으신 경우 사이드바의 피드백 제공 메뉴를 통해 간단히 의견을 남겨 주십시오.",
  "adg3.onboarding.user.optin.done": "알겠습니다",
  "adg3.onboarding.user.optin.title": "지금 Confluence가 모든 분들을 위해 새로운 모습으로 출시되었습니다",
  "adg3.send.feedback": "피드백 전송",
  "adg3.sidebar.button.configure": "사이드바 구성",
  "adg3.sidebar.button.done": "완료",
  "adg3.sidebar.button.gotit": "확인",
  "adg3.sidebar.link.disable": "비활성화",
  "adg3.sidebar.link.enable": "활성화",
  "adg3.user.profile.other": "나의 Confluence",
  "admin.section.security.title": "사용자 및 보안",
  "administration.name": "관리",
  "all.updates.mainBanner": "특이 사항은 없습니다... 아직",
  "all.updates.subBanner": "이 사이트에서 발생하는 모든 사항을 최신으로 유지합니다. 새 페이지, 파일, 편집 및 댓글 모두 여기에 표시됩니다.",
  "all.updates.subBanner2": "차세대 혁신을 일으킬 때입니다.",
  "all.updates.title": "모든 변경사항",
  "anonymous.name": "익명",
  "archived.spaces": "보관한 스페이스",
  "atlassian.can.contact": "귀하의 피드백과 관련한 후속조치를 위해 귀하께 연락드려도 되겠습니까?",
  "atlassian.home.name": "Atlassian 홈",
  "attach.files.no.permission": "여기에 파일을 삽입하려면 사용 권한을 요청해야 합니다.",
  "attach.files.tip.close": "알겠습니다.",
  "attach.files.tip.desc": "파일을 끌어놓기로 직접 페이지에 삽입할 수 있습니다.",
  "attach.files.tip.title": "도움말:",
  "attach.files.upload.files": "파일 업로드",
  "attach.files.upload.images": "그림 업로드",
  "audit.logging.category.user.management": "사용자 및 그룹",
  "aui.sidebar.collapse.tooltip": "사이드바 접기 ( [ )",
  "aui.sidebar.expand.tooltip": "사이드바 펼치기 ( [ )",
  "author.name": "저자",
  "blog.personal.name": "개인 블로그",
  "blog.post": "블로그 게시물",
  "blog.word": "블로그",
  "blogtree.failed.load.content": "블로그 게시물을 불러올 수 없습니다.",
  "blueprint.navigation.items.create.new.template": "새 템플릿 만들기",
  "blueprint.navigation.items.create.new.template.disabled": "스페이스 관리자만 템플릿을 만들 수 있습니다",
  "blueprint.navigation.items.filter.for.templates": "템플릿 필터링",
  "blueprint.navigation.items.page.templates.header": "페이지 템플릿",
  "button.cancel": "취소",
  "cache.name.com.atlassian.confluence.pages.Draft": "임시본",
  "calendar.share.button.keyboard.shortcut.desc": "공유",
  "calendar3.addcalendar": "캘린더 추가",
  "calendar3.helptip.learn.more": "더 알아보기",
  "calendar3.spacecalendars.header": "캘린더",
  "calendar3.spacecalendars.onboarding.button.add.label": "캘린더 추가",
  "calendar3.spacecalendars.onboarding.intro": "캘린더를 추가해서 팀의 부재를 추적하고, Jira 프로젝트를 계획하며 모두의 일정을 중요 날짜 위주로 정리하세요.",
  "calendar3.spacecalendars.onboarding.title": "팀 또는 프로젝트를 위한 진실의 원천",
  "cancel.name": "취소",
  "captcha.response.failed": "입력한 단어가 화면에 표시된 단어와 일치하지 않습니다.",
  "categories.name": "분류",
  "changeboarding.dnd.pagetree.spacesettings.banner": "사이드바에서 끌어서 놓기로 페이지 순서를 변경하는 기능으로 스페이스를 체계화하기가 더욱 쉬워졌습니다",
  "changeboarding.dnd.pagetree.spotlight.message": "끌어 놓아서 페이지를 이동하고 스페이스를 구성합니다.",
  "changes-diff.heading.key": "키",
  "changes-diff.these.lines.were.added": "이 줄을 추가했습니다.",
  "changes-diff.these.lines.were.removed": "이 줄을 삭제했습니다.",
  "changes-diff.this.content.was.modified": "서식을 변경했습니다.",
  "clear.name": "삭제",
  "clipboardaccess.browser.not.supported": "사용자의 브라우져가 클립보드에서 그림을 붙여넣기 하는 것을 지원하지 않습니다.",
  "clipboardaccess.ok": "확인",
  "close.draft.name": "초안 닫기",
  "close.name": "닫기",
  "collab.edit.user.limit.msg.body": "<p>이 페이지의 인기가 너무 높아서, 동시 편집기의 최고 한도에 도달했습니다.</p><p>많이 붐비지 않을 때 다시 시도해 주세요.</p>",
  "collab.edit.user.limit.msg.title": "지금은 이 페이지를 편집할 수 없습니다",
  "collab.status.connected": "실행할 준비 완료",
  "collab.status.connecting": "연결하는 중...",
  "collab.status.error": "변경 내용을 저장할 수 없습니다",
  "collab.status.tooltip.error": "쓴 글을 복사하고 이 페이지를 새로 고침하면 다시 연결해 보겠습니다.",
  "collab.status.tooltip.failure": "서버에 접근할 수 없습니다. 인터넷 연결 상태를 확인하십시오. 계속하여 다시 연결을 시도합니다.",
  "collab.status.tooltip.success": "임시본의 변경 내용 전체를 자동으로 저장합니다.",
  "collapse.name": "축소",
  "colourname.property.style.bordercolour": "테두리 및 구분선",
  "colourname.property.style.breadcrumbstextcolour": "상단 막대 글자",
  "colourname.property.style.headerbuttonbasebgcolour": "머릿글 단추 배경",
  "colourname.property.style.headerbuttontextcolour": "머릿글 단추 글자",
  "colourname.property.style.headingtextcolour": "제목",
  "colourname.property.style.linkcolour": "링크",
  "colourname.property.style.menuitemselectedbgcolour": "선택된 메뉴 항목 배경",
  "colourname.property.style.menuitemselectedtextcolour": "선택된 메뉴 항목 글자",
  "colourname.property.style.menuitemtextcolour": "페이지 메뉴 항목 명",
  "colourname.property.style.menuselectedbgcolour": "페이지 메뉴 배경 선택",
  "colourname.property.style.navbgcolour": "네비게이션 탭 배경",
  "colourname.property.style.navselectedbgcolour": "네비게이션 탭 하이라이트 배경",
  "colourname.property.style.navselectedtextcolour": "네비게이션 탭 하이라이트 글자",
  "colourname.property.style.navtextcolour": "네비게이션 탭 글자",
  "colourname.property.style.searchfieldbgcolour": "검색 필드 배경",
  "colourname.property.style.searchfieldtextcolour": "검색 필드 텍스트",
  "colourname.property.style.spacenamecolour": "스페이스 이름 텍스트",
  "colourname.property.style.topbarcolour": "상단 바",
  "colourname.property.style.topbarmenuitemtextcolour": "상단 바 메뉴 항목 글자",
  "colourname.property.style.topbarmenuselectedbgcolour": "상단 바 선택된 메뉴 배경",
  "colourname.property.style.topbarmenuselectedtextcolour": "상단 바 선택된 메뉴 글자",
  "com.atlassian.confluence.contributors.contributors.label": "작성자",
  "com.atlassian.confluence.extra.officeconnector.viewfile.label": "파일 보기",
  "com.atlassian.confluence.extra.team-calendars.calendar.helptip.close": "알겠습니다, 감사합니다!",
  "com.atlassian.confluence.pages.actions.EditPageAction.action.name": "페이지 편집",
  "com.atlassian.confluence.plugins.confluence-roadmap-plugin.roadmap.label": "로드맵 플래너",
  "com.atlassian.confluence.plugins.pagetree.pagetree.label": "페이지 트리",
  "com.atlassian.confluence.plugins.recently.viewed.filter": "필터",
  "com.atlassian.confluence.plugins.recently.viewed.footer.hint": "힌트: \"g\"키를 누르고 \"r\"키를 누르면 어디서든 이 메뉴를 바로 열 수 있습니다.",
  "com.atlassian.confluence.plugins.recently.viewed.title": "최근에 본 페이지",
  "com.atlassian.confluence.plugins.status-macro.status.label": "상태",
  "com.atlassian.mywork.header.notifications": "알림",
  "comment.display.name.anonymous": "익명",
  "comment.edit": "편집",
  "comment.edited": "편집됨",
  "comment.name.tooltip": "댓글 추가",
  "comment.notification.enable": "이 문서 주시하기",
  "comment.permalink": "영구연결",
  "comment.plural": "{0} 댓글",
  "comment.remove": "삭제",
  "comment.reply": "대답",
  "comment.singular": "1 개의 댓글",
  "compare.selected": "선택한 버전 비교",
  "configuration.name": "환경설정",
  "confluence.extra.attachments.attachments.label": "첨부 파일",
  "confluence.extra.jira.jira.label": "Jira",
  "confluence.extra.masterdetail.detailssummary.label": "페이지 속성 보고서",
  "confluence.home": "컨플루언스 홈",
  "confluence.macros.advanced.children.label": "하위 페이지 표시",
  "confluence.macros.advanced.contentbylabel.label": "레이블별 문서",
  "confluence.macros.advanced.recently-updated.label": "최근 변경사항",
  "confluence.mobile.nav.switch.to.mobile.action": "Confluence 모바일로 전환",
  "confluence.mobile.nav.switch.to.mobile.text": "현재 모바일 기기로 데스크톱 버전을 보고 계십니다.",
  "confluence.mobile.refresh": "새로고침",
  "confluence.request.access.pagerestricted.inherited.description": "상위 페이지에서 제한을 상속하기 때문입니다. 스페이스 관리자 또는 이 페이지를 공유한 사용자가 액세스 권한을 부여할 수 있습니다.",
  "confluence.request.access.pagerestricted.request.access.button": "접근 요청",
  "confluence.request.access.pagerestricted.requestaccess.description": "액세스 요청 버튼을 누르면, 액세스 권한을 부여할 수 있는 사람이 검색됩니다.",
  "confluence.request.access.pagerestricted.requestaccess.title.edit.page": "이 페이지를 편집할 수 있는 권한이 없습니다",
  "confluence.request.access.pagerestricted.requestaccess.title.view.page": "이 페이지를 볼 수 있는 권한이 없습니다",
  "confluence.user.profile.department": "부서",
  "confluence.user.profile.location": "위치",
  "confluence.user.profile.position": "직급",
  "connect.addon.wait.or": "기다리거나",
  "content.empty": "댓글 내용이 비어 있습니다. 내용이 없는 댓글은 생성할 수 없습니다.",
  "content.kind.decisions": "Decision",
  "content.kind.file-list": "File list",
  "content.kind.jirareport": "Jira report",
  "content.kind.kb-how-to-article": "How to article",
  "content.kind.kb-troubleshooting-article": "Troubleshooting article",
  "content.kind.meeting-notes": "Meeting notes",
  "content.kind.product-requirements": "Product requirements",
  "content.kind.retrospective": "Retrospective",
  "content.kind.shared-links": "Shared links",
  "content.kind.task-report": "Task report",
  "content.type.attachment": "첨부 파일",
  "content.type.blogpost": "블로그",
  "content.type.page": "페이지",
  "cq.header.title": "질문",
  "create.blog.post.event.description": "블로그 게시물을 만들기",
  "create.drawer.header": "만들기",
  "create.drawer.page.selector.all.pages.in.space": "이 스페이스의 모든 페이지",
  "create.drawer.page.selector.location.header": "위치",
  "create.drawer.page.selector.no.page.found": "페이지 찾을 수 없음",
  "create.drawer.page.selector.no.parent.page": "상위 페이지 없음",
  "create.drawer.page.selector.pages.loading": "페이지 로드 중",
  "create.drawer.page.selector.parent.page": "상위 페이지",
  "create.drawer.page.selector.parent.page.tooltip.help": "블로그, 캘린더 및 질문은 상위 페이지 밑에 표시되지 않습니다.",
  "create.drawer.page.selector.recent.pages": "최근 페이지",
  "create.drawer.page.selector.select.parent.page": "상위 페이지 선택",
  "create.drawer.space.selector.header": "스페이스",
  "create.drawer.space.selector.location.header": "위치",
  "create.drawer.space.selector.no.space.found": "스페이스가 없습니다",
  "create.drawer.space.selector.recent.spaces": "최근 스페이스",
  "create.drawer.space.selector.search.spaces": "모든 스페이스",
  "create.drawer.space.selector.select.a.space": "스페이스 선택",
  "create.drawer.space.selector.spaces.loading": "스페이스 로드 중",
  "create.drawer.space.selector.starred.spaces": "별표 표시된 스페이스",
  "create.drawer.template.failed.to.load.atlassian.support": "Atlassian 지원팀에 문의하시기 바랍니다.",
  "create.drawer.template.failed.to.load.content": "페이지를 새로 고치고 다시 시도하세요. 문제가 지속되는 경우",
  "create.drawer.template.failed.to.load.title": "템플릿 로드 실패",
  "create.name": "만들기",
  "css.file": "CSS 파일",
  "current.space": "현재 스페이스",
  "default.space.homepage.title": "{0} 홈",
  "delete.name": "삭제",
  "desc.colourscheme": "다음 색상은 이 색상 테마용으로 변경할 수 있습니다.",
  "description.name": "설명",
  "discard.name": "버리기",
  "discover.applications": "응용프로그램 검색",
  "draft": "임시본",
  "draft.no.content": "이 임시본에는 내용이 없습니다.",
  "edit.comment": "댓글 편집",
  "edit.labels": "레이블 추가",
  "editor-help.fabric.help.center.feedback.item": "피드백",
  "editor.adf.parsing.error.details": "오류 세부 정보:",
  "editor.adf.parsing.error.message.prod": "페이지를 새로 고치고 다시 시도하십시오. 문제가 계속될 경우 <a target=\"_blank\" href=\"{link}\">Atlassian 지원</a>에 문의하시기 바랍니다.",
  "editor.adf.parsing.error.message.staging": "알림을 받았습니다. Slack의 <a target=\"_blank\" href=\"{link}\">#cc-content-experience</a> 채널에서도 이 내용을 논의하실 수 있습니다.",
  "editor.adf.parsing.error.title.prod": "편집기를 불러오지 못했습니다.",
  "editor.adf.parsing.error.title.staging": "이 문서를 ADF로 변환하는 도중 문제가 있었습니다",
  "editor.attachments": "{0}",
  "editor.attachments.plural": "{0} 첨부",
  "editor.attachments.singular": "{0} 첨부",
  "editor.attachments.zero": "첨부 파일",
  "editor.autocomplete.file.header.text": "파일 추천",
  "editor.autocomplete.links.create.link": "페이지를 만들기 위한 연결 삽입",
  "editor.autocomplete.links.dialog.search": "‘{0}’ 검색",
  "editor.autocomplete.links.dialog.search.no.text": "검색",
  "editor.autocomplete.links.header.text": "추천 연결",
  "editor.autocomplete.links.web.link": "웹 연결 삽입",
  "editor.autocomplete.macros.dialog.browse": "매크로 탐색기 열기",
  "editor.autocomplete.macros.error.load.header": "매크로 정보 가져오기 실패",
  "editor.autocomplete.macros.error.load.retrylink": "다시 시도",
  "editor.autocomplete.macros.header.text": "추천 매크로",
  "editor.autocomplete.media.files.dialog.browse": "파일 목록 열기",
  "editor.autocomplete.media.header.text": "추천 미디어",
  "editor.autocomplete.media.images.dialog.browse": "그림 탐색기 열기",
  "editor.autocomplete.media.macros.dialog.browse": "다른 미디어 삽입",
  "editor.autoformat.sampletext.firstcell": "첫째 칸",
  "editor.autoformat.sampletext.heading": "머릿말",
  "editor.buttons.disable.by.empty.title.tooltip": "페이지를 게재하려면 제목이 필요합니다.",
  "editor.buttons.disable.by.not.saving.tooltip": "아직 작업 중...",
  "editor.buttons.disable.by.saving.tooltip": "아직 페이지를 저장하는 중입니다.",
  "editor.cancel.discard.changes.confirmation": "변경 사항 버리기",
  "editor.cancel.discard.changes.message": "입력한 모든 내용이 취소됩니다. 확인하세요.",
  "editor.cancel.discard.changes.title": "모든 변경의 취소를 확인",
  "editor.cant.publish.changes": "변경사항 배포 불가",
  "editor.change.comment": "무엇을 변경했습니까?",
  "editor.close.publish.tooltip": "게시하지 않고 변경 사항 저장",
  "editor.close.update.tooltip": "업데이트하지 않고 변경 사항 저장",
  "editor.collab.user.limit.body": "이 페이지는 인기가 높아서 동시 편집자 숫자가 최대치에 도달했습니다. 붐비지 않을 때 다시 시도하십시오.",
  "editor.collab.user.limit.title": "지금은 이 페이지를 편집할 수 없습니다.",
  "editor.collaborative-editing.load.error": "에디터를 불러오는 데 평소보다 많은 시간이 소요되고 있습니다. 계속 불러와지지 않으면 잠시 기다린 뒤 페이지를 새로고침하세요. 문제가 지속되면 Confluence 관리자에게 문의하세요.",
  "editor.collaborative-editing.refresh-editor.error": "편집기를 로드하는 동안에 문제가 발생했습니다. 다시 시도해 주세요.",
  "editor.collaborative.mode.disabled": "공동 편집이 현재 오프라인입니다. 작업을 복사하고 페이지를 새로 고침해 편집을 계속하세요.",
  "editor.collaborative.mode.enabled": "공동 편집이 꺼졌었지만 다시 작동하고 있습니다. 변경 내용을 복사한 뒤 페이지를 새로 고침해 계속 편집하세요.",
  "editor.content.appearance.toggle.fixed.width": "페이지 전자 적용",
  "editor.content.appearance.toggle.full.width": "페이지 고정 너비 적용",
  "editor.content.placeholder.11": "이 페이지에 목차, 날짜, 로드맵 등 모든 종류의 멋진 것을 추가할 수 있다는 것을 알고 계셨습니까? 목록을 열려면 /를 입력하십시오.",
  "editor.content.placeholder.ai": "/ai를 입력하여 Atlassian Intelligence를 사용하거나 /를 입력하여 요소를 추가하거나 @를 입력하여 사용자를 멘션하세요(해당 사용자에게 알림을 보냅니다).",
  "editor.content.placeholder.bpqa": "요소의 목록을 보려면 /를 입력하거나 사용자를 멘션하려면 @를 입력하거나 아래 중에서 선택하세요.",
  "editor.content.placeholder.bpqa.ai": "'/ai'를 입력하여 Atlassian Intelligence를 사용하거나 /를 입력하여 요소를 사용하거나 @를 입력하여 사용자를 멘션하거나 아래에서 선택하세요.",
  "editor.content.placeholder.easy.mentions": "모든 요소를 보려면 /를 입력하거나 사용자를 멘션하려면 @를 입력하세요.",
  "editor.content.placeholder.slash": "요소를 삽입하려면 /를 입력하세요",
  "editor.content.placeholder.slash.bracket": "/를 입력하면 어떤 요소든지 빠르게 삽입할 수 있습니다",
  "editor.content.reconciliation.error.details": "오류 세부 정보:",
  "editor.content.reconciliation.error.fatal.prod": "알림을 받았습니다. 몇 분 후에 다시 시도해 주세요. 문제가 계속 나타나면 Atlassian 지원에 문의해 주시기 바랍니다.",
  "editor.content.reconciliation.error.fatal.staging": "알림을 받았습니다. Slack의 #cc-content-experience 채널에서도 이 내용을 논의하실 수 있습니다.",
  "editor.content.reconciliation.error.retrying": "{0}초 후 다시 시도",
  "editor.content.reconciliation.error.title": "이 페이지를 로드하지 못했습니다.",
  "editor.content.reconciliation.networkerror.fatal.prod": "페이지를 새로 고치면 문제가 해결될 수 있습니다. 문제가 지속되는 경우 <a href=\"https://support.atlassian.com/contact/#/\" target=\"_blank\">Atlassian 고객 지원팀</a> 또는 스페이스 관리자에게 문의하세요.",
  "editor.content.reconciliation.networkerror.title": "콘텐츠를 로드하는 동안 문제가 발생했습니다.",
  "editor.discard-on-close.tooltip": "비어 있는 초안 버리기",
  "editor.discard-to-published.button.label": "삭제",
  "editor.discard-to-published.button.tooltip": "페이지를 마지막 출판된 버전으로 되돌리기",
  "editor.discard-to-published.dialog.title": "미발행된 변경 내용을 삭제하시겠습니까?",
  "editor.discard-to-published.dialog.warning": "에디터가 이 페이지를 마지막 출판된 버전으로 복원합니다. 만약 누군가가 페이지에 출판되지 않은 변경사항을 적용했다면, 이 변경사항들 역시 버려지게 됩니다.",
  "editor.discard-to-published.error.message": "현재 페이지의 마지막 출판된 버전을 얻을 수 없습니다. 잠시 기다린 후 작성본을 다시 삭제해보세요.",
  "editor.discard-to-published.error.title": "마지막 출판된 버전으로 되돌릴 수 없습니다",
  "editor.discard-to-published.success.message": "최근 발행된 버전으로 성공적으로 복구되었습니다",
  "editor.draft.can.be.migrated": "이것이 협업편집입니다! 귀하가 이 페이지에서 계속 작업하시려면 내용을 새로운 드래프트로 이전해야 합니다.<br> <a href={0}>지금 이전</a>",
  "editor.dynamic-macro.preview.limit.desc": "초안의 동적 매크로 미리 보기는 공유된 초안을 이용할 수 있는 경우에만 완전하게 지원됩니다.",
  "editor.ellipsis.blog.delete": "게시되지 않은 블로그 게시물 삭제",
  "editor.ellipsis.import-document": "템플릿을 열고 문서 가져오기",
  "editor.ellipsis.open.template.browser": "템플릿 탐색기 열기",
  "editor.ellipsis.open.templates.and.import": "템플릿 및 문서 가져오기",
  "editor.ellipsis.page.delete": "게시되지 않은 페이지 삭제",
  "editor.ellipsis.remove": "마지막으로 게시된 버전으로 되돌리기",
  "editor.ellipsis.resolved.comments": "해결된 댓글",
  "editor.ellipsis.view-changes": "변경 사항 보기",
  "editor.error.delayed.publishing": "계속 게시를 시도하겠습니다. 너무 오래 걸리면 페이지를 새로 고치고 <strong>게시</strong>를 클릭하세요.",
  "editor.error.delayed.publishing.title": "콘텐츠를 게시하는 동안 문제가 발생했습니다.",
  "editor.excerpt.include.macro.error": "\"{0}\"에서 예외를 로드하는 도중 오류가 발생했습니다.",
  "editor.excerpt.panel.title.loading": "로드하는 중...",
  "editor.fabric.share.invite.to.edit.empty.blog.post.title": "제목 없는 블로그 게시물",
  "editor.fabric.share.invite.to.edit.empty.page.title": "제목 없는 페이지",
  "editor.fabric.share.invite.to.edit.form.title": "편집에 초대",
  "editor.files.may.be.uploading": "일부 파일이 아직 업로드 중일 수 있습니다. 잠시 후 다시 시도해 보십시오. 그래도 안 될 경우, 페이지를 새로고침하고 배포 전에  손상된 것으로 보이는 파일을 다시 업로드하십시오.",
  "editor.generic.refresh": "편집기에 문제가 발생하였습니다. 계속해서 편집하시려면 저장하지 못한 변경 사항들을 복사하신 후, 현재 보고 계신 페이지를 리프레쉬하시기 바랍니다.",
  "editor.go.back": "뒤로 가기",
  "editor.heartbeat.unauthorised.warning.generic.body": "이 콘텐츠는 이동, 제한 또는 삭제되었습니다. 필요한 항목을 복사하고 편집기를 닫는 것이 좋습니다.",
  "editor.heartbeat.unauthorised.warning.generic.title": "이 페이지에 접근할 수 없습니다",
  "editor.heartbeat.unauthorised.warning.page-move.body": "페이지의 이동이나 제한 사항의 변경으로 인해 게시할 수 없습니다. 필요한 항목을 복사하고 편집기를 닫는 것이 좋습니다.",
  "editor.heartbeat.unauthorised.warning.page-move.title": "페이지의 사용 권한이 변경되었습니다",
  "editor.help.how.to.use.blueprint": "{blueprintType} 사용법",
  "editor.help.templates": "페이지 템플릿 사용",
  "editor.help.updates": "업데이트 편집 중",
  "editor.help.updates.1.description": "편집 개선 작업 1단계가 블로그 게시물에서 이루어졌습니다. 반응형 콘텐츠,  더 나은 이미지 처리, 보다 간소화된 인터페이스가 제공됩니다. 새 블로그 게시물을 작성하면서 확인하십시오.",
  "editor.help.updates.1.title": "블로그 게시물",
  "editor.help.updates.2.description": "회의록에 새 편집 경험을 추가했습니다. 마지막 업데이트에는 표를 클릭하여 토글하는 첨단 표 기능 및 개선사항이 포함되어 속도와 신뢰성이 향상되었습니다.",
  "editor.help.updates.2.title": "회의록",
  "editor.hints.close": "힌트 닫기",
  "editor.hints.next": "다음 힌트",
  "editor.labels": "{0}",
  "editor.labels.desc": "페이지 레이블 편집",
  "editor.labels.plural": "{0} 레이블",
  "editor.labels.singular": "{0} 레이블",
  "editor.labels.zero": "레이블",
  "editor.learn.more": "자세히 알아보기",
  "editor.location.desc": "위치 추가",
  "editor.minor.edit": "지켜보는 사람에게 알림",
  "editor.offline.before.save.error": "서버와 통신할 수 없음. 현재 저장은 불가능합니다.",
  "editor.offline.preview.error": "서버에 연결할 수 없습니다. 인터넷 연결 상태와 컨플루언스 실행 및 동작 여부를 확인하시기 바랍니다.",
  "editor.offline.save.error": "서버와 통신할 수 없습니다. 지금은 저장을 할 수 없습니다.",
  "editor.offline.save.error.generic": "요청을 처리하는 동안 오류가 발생했습니다.",
  "editor.offline.save.noauthorized": "세션이 만료되었습니다. 계속 작업하려면 다시 로그인하거나 다른 계정으로 전환해야 합니다. \n <div><a href=\"/login?application=confluence\">로그인 또는 다른 계정으로 전환</a></div>",
  "editor.offline.save.noauthorized.title": "서버에 접속할 수 없습니다.",
  "editor.offline.save.page.exist.content": "이 스페이스에 제목이 '{'0'}'인 페이지가 이미 있습니다. 페이지에 다른 제목을 입력하세요.",
  "editor.onboarding.draft.placeholder": "목차 또는 로드맵과 같이 페이지에 추가할 수 있는 유용한 구성 요소의 목록을 보려면 /를 입력하세요.<br/>또는 떠오르는 것이 없다면 오른쪽에 있는 템플릿 중에서 하나를 선택해 시작하세요. →",
  "editor.onboarding.spotlight.body": "변경사항과 이유를 알아보십시오.",
  "editor.onboarding.spotlight.finish": "알겠습니다.",
  "editor.onboarding.spotlight.title": "템플릿을 하나씩 업데이트하는 중입니다.",
  "editor.onboarding.step1.content": "가독성 향상, 더 스마트한 서식 도구, 더 현대적인 분위기 등 요청하신 기능들을 사용하실 수 있게 작업 중입니다. <br /><a href=''{linkCAC}' target='_blank'>무엇이 바뀌는지 자세히 알아보세요.</a>",
  "editor.onboarding.step1.title": "더 용이해진 블로그 포스트",
  "editor.onboarding.step2.content": "가장 많이 사용하는 기능들은 도구 모음에 있고, 고급 도구들은 플러스 기호 아래쪽에 표시됩니다. 새로 다양하게 추가된 이모지로 하루를 밝게 수놓을 수도 있습니다! <br/><a href=''{linkCAC}' target='_blank'>무엇이 바뀌는지 자세히 알아보세요.</a>",
  "editor.onboarding.step2.title": "찾는 게 있으세요?",
  "editor.onboarding.step3.content": "현재 작업 중인 공간입니다. 끝내주게 만들려면 도움이 필요해요. 저희에게 피드백을 보내 주시고 <a href=''{linkCAC}' target='_blank'>Confluence 페이지</a>를 팔로우해서 변경 사항에 관한 업데이트를 받아 보세요. <br/><a href=''{linkCAC}' target='_blank'>무엇이 바뀌는지 자세히 알아보세요.</a>",
  "editor.onboarding.step3.title": "뭔가 굉장한 것을 함께 만들어 보아요",
  "editor.page.can.not.be.accessed.message": "세션이 만료된 것 같습니다. 계속 작업하려면 다시 로그인하거나 다른 계정으로 전환해야 합니다. \n <div><a href=\"/login?application=confluence\">로그인 또는 다른 계정으로 전환</a></div>",
  "editor.page.can.not.be.accessed.title": "이 콘텐츠에 액세스할 수 없습니다.",
  "editor.page.conflict.message": "페이지를 새로 고쳐 연결을 다시 설정해 보십시오.",
  "editor.page.conflict.title": "서버와 동기화할 수 없습니다.",
  "editor.page.is.too.big": "이 페이지는 너무 커서 저장할 수 없습니다. 이는 여러 개의 페이지로 분할할 수 있으며, <a href=\"https://confluence.atlassian.com/conf51/include-page-macro-336169384.html\" target=\"_blank\">페이지 매크로를 포함</a>시켜 콘텐츠를 표시할 수 있습니다.",
  "editor.page.is.trashed.message": "콘텐츠를 복사한 다음, 새 페이지에 추가하거나 <div><a href=\"{0}/pages/viewtrash.action?key={1}\" target=\"_blank\">이 페이지를 휴지통에서 복원하고</a> 다시 시도해 주세요.</div>",
  "editor.page.is.trashed.title": "이 콘텐츠가 삭제되었습니다.",
  "editor.page.legacy.draft.deprecated": "지금 공동 편집을 하실 수 있습니다. 귀하의 편집 세션을 재시작하기 위해서 먼저 컨텐츠를 복사하시고, 현재 보고 계시는 페이지를 다시 한번 편집하신 후, 복사된 내용을 붙여 넣고나서 저장해주시기 바랍니다.",
  "editor.page.moved.message.body": "그래도 괜찮습니다. 준비가 되면 변경 사항을 게시할 수 있습니다. <br /><br /> 새로운 위치: {0}",
  "editor.page.moved.message.title": "{0}님이 이 페이지를 이동함",
  "editor.page.moved.message.unknown.mover": "다른 사용자",
  "editor.placeholder.broken.image": "깨진 그림",
  "editor.placeholder.broken.link": "깨진 연결",
  "editor.placeholder.broken.macro": "깨진 매크로",
  "editor.placeholder.error": "오류",
  "editor.preview.error": "미리보기를 불러오는 동안 오류가 발생했습니다. 잠시 후 다시 시도해주세요.",
  "editor.publish.blog": "출판",
  "editor.publish.blog.desc": "블로그 글을 출판",
  "editor.publish.external.share.label": "외부 공유",
  "editor.publish.hotkey.description": "이 콘텐츠를 게시하려면 키보드에서 {keyCombination}을(를) 선택하세요.",
  "editor.publish.with.comment": "버전 메모 포함하여 게시...",
  "editor.publish.without.notify": "관찰자에게 알리지 않고 게시",
  "editor.quit-dialog.button.delete.blog.exit": "블로그 게시물 삭제",
  "editor.quit-dialog.button.delete.page.exit": "페이지 삭제",
  "editor.quit-dialog.button.discard.changes.by.many": "<strong>모두의</strong> 변경 내용 삭제",
  "editor.quit-dialog.button.discard.changes.by.one": "<strong>모든</strong> 변경 내용 삭제",
  "editor.quit-dialog.button.discard.collaborative.tooltip": "모든 미발행 변경 내용 삭제",
  "editor.quit-dialog.button.discard.limited.tooltip": "공동 편집이 꺼져 있습니다. 다시 켜지면 변경 내용을 삭제할 수 있습니다.",
  "editor.quit-dialog.button.revert.blog.exit": "블로그 게시물 되돌리기",
  "editor.quit-dialog.button.revert.page.exit": "페이지 되돌리기",
  "editor.quit-dialog.button.save.exit": "임시 저장 문서 보관",
  "editor.quit-dialog.cancel.changes.by.many": "<p>귀하와 다른 사람들이 수정했으나 아직 발행되지 않은 내용이 있습니다.</p><p>변경 내용을 삭제하면 다음 사람들이 수정한 변경 내용도 함께 삭제되며, 이 페이지는 마지막 발행 버전으로 되돌아갑니다. 본 동작 실행 시 다음 사람들은 작업 내용을 복구할 수 없습니다.</p> <p>문서를 수정한 사람은 다음과 같습니다:</p>",
  "editor.quit-dialog.cancel.changes.by.one": "<p>아직 발행되지 않은 변경 내용이 있습니다.</p> <p>변경 내용 삭제 시 발행되지 않은 변경 내용은 삭제됩니다. 이 동작은 되돌릴 수 없습니다.</p>",
  "editor.quit-dialog.delete.blogpost.changes.by.many": "다른 사람들과 함께 작업한 이 블로그 포스트가 영구적으로 삭제됩니다.",
  "editor.quit-dialog.delete.blogpost.changes.by.one": "게시되지 않은 블로그 게시물을 삭제하면, 영구적으로 사라집니다.",
  "editor.quit-dialog.delete.page.changes.by.many": "본인과 다른 사람들이 작업한 페이지가 영구적으로 삭제됩니다.",
  "editor.quit-dialog.delete.page.changes.by.one": "게시되지 않은 페이지를 삭제하면, 영구적으로 사라집니다.",
  "editor.quit-dialog.last.edited": "마지막 편집",
  "editor.quit-dialog.link.hide.diff": "변경 내용 감추기",
  "editor.quit-dialog.link.show.diff": "변경 내용 보기",
  "editor.quit-dialog.publish.changes": "<p>귀하와 다른 사람들이 편집했으며 아직 발행되지 않은 내용이 있습니다.</p><p>이 사람들이 편집한 변경 내용은 다음과 같습니다:</p>",
  "editor.quit-dialog.revert.blogpost.changes.by.one": "이 블로그 게시물이 마지막으로 게시된 이후 적용된 모든 변경 사항이 영구적으로 삭제됩니다",
  "editor.quit-dialog.revert.changes.by.many": "이 페이지가 마지막으로 게시된 이후 다음 사람들이 수행한 모든 변경 사항이 영구적으로 삭제됩니다.",
  "editor.quit-dialog.revert.page.changes.by.one": "이 페이지가 마지막으로 게시된 이후 적용된 모든 변경 사항이 영구적으로 삭제됩니다.",
  "editor.quit-dialog.title.blogpost.delete": "게시되지 않은 블로그 게시물을 삭제하시겠습니까?",
  "editor.quit-dialog.title.discard": "마지막으로 게시된 버전으로 되돌리시겠습니까?",
  "editor.quit-dialog.title.exit": "에디터 닫기",
  "editor.quit-dialog.title.page.delete": "게시되지 않은 페이지를 삭제하시겠습니까?",
  "editor.quit-dialog.title.publish": "모든 변경 내용을 발행하시겠습니까?",
  "editor.restrictions.desc": "페이지 제한 편집",
  "editor.return.to.edit": "편집 모드로 돌아가기",
  "editor.satisfaction.survey.description": "편집 경험은 어떠셨습니까?",
  "editor.satisfaction.survey.final.description": "피드백이 제출되었습니다.",
  "editor.satisfaction.survey.final.title": "감사합니다",
  "editor.satisfaction.survey.question.bad": "안타깝습니다. 무슨 문제가 있었습니까? (선택사항)",
  "editor.satisfaction.survey.question.good": "감사합니다! 마음에 들었던 점은 무엇입니까? 개선할 점은 무엇입니까? (선택사항)",
  "editor.satisfaction.survey.title": "페이지가 게재되었습니다",
  "editor.save.draft.desc": "임시본 저장",
  "editor.save.page.desc": "사용자의 페이지 저장",
  "editor.shared.draft.done.desc": "초안 저장(비어 있으면 버리기)",
  "editor.shared.draft.publish.desc": "변경 내용 공개",
  "editor.shared.draft.update.desc": "발행된 페이지 업데이트",
  "editor.shortcuts": "키보드 단축키 편집",
  "editor.synchrony.publish-page.message": "현재 페이지를 {0}번 공개함.",
  "editor.template.changing.variable.dialog.title": "템플릿 변수 편집",
  "editor.template.variable.input.creation.error.action": "Atlassian 지원팀에 문의하기",
  "editor.template.variable.input.creation.error.description": "페이지를 새로 고치고 다시 시도하세요. 문제가 지속되면 아래 링크를 사용하여 문제를 알려주세요",
  "editor.template.variable.input.creation.error.title": "문제가 발생했습니다.",
  "editor.template.variable.list.field.placeholder": "옵션 1, 옵션 2, 옵션 3",
  "editor.template.variable.name.field": "변수 이름",
  "editor.title.is.empty": "발행 버튼을 누르기 전에 페이지 제목을 추가하세요.",
  "editor.title.is.empty.title": "이 페이지의 이름이 필요합니다",
  "editor.title.placeholder": "페이지 제목",
  "editor.title.too.long": "제목은 255글자 이상일 수 없습니다.",
  "editor.unavailable.generic.body": "현재 편집이 지원되지 않습니다. 몇 분 후에 다시 시도하세요.",
  "editor.unavailable.title": "수정할 수 없습니다",
  "editor.unpublished.changes.lozenge.label": "배포 안됨",
  "editor.unpublished.changes.lozenge.tooltip": "이 페이지에 배포하지 않는 변경 내역이 있습니다.",
  "editor.waiting.to.publish.changes": "파일 업로드가 아직 진행 중일 수 있습니다.",
  "editor.waiting.to.publish.changes.title": "시간이 약간 걸리고 있습니다. 잠시만 기다려 주세요.",
  "email.text.added.by": "추가",
  "error.connection.lost.body": "사용자가 다시 연결할 때까지 이곳에서 기다립니다.",
  "error.connection.lost.title": "연결이 끊어진 것 같습니다.",
  "error.connection.recovered.action": "콘텐츠를 다시 로드합니다.",
  "error.connection.recovered.title": "다시 연결됨",
  "error.notfound.title": "아, 이런, 해당 페이지를 찾을 수 없습니다.",
  "error.recovery.body": "변경 사항은 유지됩니다. 페이지를 새로 고친 후 다시 시도하세요.",
  "error.recovery.title": "편집기를 로드하는 동안 문제가 발생했습니다",
  "error.server-error.body": "나중에 다시 시도하십시오.",
  "error.server-error.title": "문제가 발생했습니다.",
  "error.session.expired.body": "다음 번에는 놓치지 않을 것을 약속합니다.",
  "error.session.expired.title": "세션이 손실된 것 같습니다.",
  "excel.file": "마이크로소프트 엑셀 스프레드시트",
  "excel.macro.file": "마이크로소프트 엑셀 매크로 사용 스프레드시트",
  "excel.template.file": "마이크로소프트 엑셀 양식",
  "excel97.file": "마이크로소프트 엑셀 시트",
  "excel97.template.file": "마이크로소프트 엑셀 97 양식",
  "existing.blogpost.placeholder": "블로그 게시 제목",
  "expand-macro.default-title": "여기를 클릭하여 펼치기...",
  "expand.name": "확장",
  "fabric.editor.announcement.datednotice.main": "{0}에 새로운 편집 경험으로 업그레이드될 것입니다.",
  "fabric.editor.announcement.dismiss": "닫기",
  "fabric.editor.announcement.greeting": "{0} 님, 안녕하세요!",
  "fabric.editor.announcement.initialnotice.main": "몇 주 내로 Confluence에서 내용을 생성하는 방식이 변경될 예정입니다.",
  "fabric.editor.announcement.link.action": "적용될 변경 사항과 새로운 기능을 알아보세요.",
  "fabric.editor.announcement.rollbacknotice.action": "기존 페이지를 예전 환경으로 되돌리는 방법을 알아보려면 공지를 읽으십시오.",
  "fabric.editor.announcement.rollbacknotice.main": "최근 귀하의 페이지가 뜻하지 않게 새로운 편집 환경으로 업데이트되었습니다. 이를 롤백해드렸습니다.",
  "fabric.editor.announcement.tryit.action": "새 페이지에서 시도해보세요.",
  "fabric.editor.announcement.tryitnotice.main": "새로운 편집 경험으로 페이지의 디자인이 더욱 향상되었으며 실시간 매크로 등 새 기능을 사용할 수 있습니다.",
  "fabric.editor.changeboarding.banner.action": "새로운 기능을 확인하세요.",
  "fabric.editor.changeboarding.banner.dismiss": "그만 보기",
  "fabric.editor.changeboarding.banner.main": "{0} 님 안녕하세요. 여러분이 보기 좋고 읽기 쉬운 콘텐츠를 만들도록 돕고자 몇 가지를 변경하고 있습니다.",
  "fabric.editor.page.removed.description": "지금 새로 고치세요.",
  "fabric.editor.page.removed.title": "이 페이지는 최근에 보관 또는 삭제되었습니다",
  "fabric.editor.permission.removed.description": "이 페이지에 대한 권한이 변경되었습니다. 관리자에게 문의하여 지원을 받으십시오.",
  "fabric.editor.permission.removed.title": "이 페이지를 표시할 수 없습니다.",
  "fabric.full.width.help.center.dialog.title": "New! Width control",
  "fabric.full.width.help.center.pageElement.details": "<p><strong>모든 페이지 요소</strong>를 수평으로 확장하면 여백이 줄어듭니다. 토글은 또한 페이지 콘텐츠를 고정 너비로 되돌립니다.</p>",
  "fabric.full.width.help.center.pageElement.title": "Full-width page toggle",
  "fabric.full.width.help.center.tableElement.details": "<p><strong>각 열과 표</strong>의 너비와 와이드 또는 전체 너비 옵션을 사용하는 대부분의 <strong>매크로</strong>를 제어합니다. 특정 요소를 대상으로 고정 너비를 유지할 수도 있습니다.</p>",
  "fabric.full.width.help.center.tableElement.title": "개별 요소 토글",
  "fabric.help.center.columns.details": "<p>페이지에 <strong>열</strong>을 추가한 후 <strong>움직이는 메뉴</strong>를 사용하여 열 구성을 2개 또는 3개로 바꿀 수 있습니다.</p>",
  "fabric.help.center.columns.title": "열",
  "fabric.help.center.dialog.title": "기본 사항 알아보기",
  "fabric.help.center.imageDisplay.details": "<p>그림을 선택한 후 <strong>핸들</strong>을 끌어다 놓아 크기를 조정하거나, <strong>움직이는 메뉴</strong>를 사용하여 정렬을 변경합니다.</p>",
  "fabric.help.center.imageDisplay.title": "그림 표시",
  "fabric.help.center.layouts.details": "<p><kbd>←</kbd> <kbd>→</kbd> 화살표를 사용하여 열, 표, 매크로의 배치 방식을 변경합니다.</p><p>어떤 화면에서도 같은 상태를 유지하는 <strong>고정 너비</strong>, 확장하여 공간을 채우는 <strong>전체 너비</strong> 또는 중간 <strong>너비</strong> 설정을 선택합니다.</p>",
  "fabric.help.center.layouts.title": "배치",
  "fabric.help.center.menuitem.title": "튜토리얼",
  "fabric.help.center.slashCommands.details": "<p><kbd>/</kbd>(슬래시)를 입력하여 메뉴를 열고, 이동 시 해당 페이지에 <strong>표</strong>, <strong>매크로</strong>, <strong>날짜</strong>와 같은 내용을 삽입합니다.</p>",
  "fabric.help.center.slashCommands.title": "슬래시 명령",
  "fabric.help.center.spotlight.body": "언제든지 여기로 돌아와서 튜토리얼을 다시 확인할 수 있습니다.",
  "fabric.help.center.spotlight.header": "리프레셔가 필요하신가요?",
  "fabric.help.center.tableManipulation.details": "<p><strong>표 테두리</strong>와 <strong>드롭다운</strong>, <strong>움직이는 메뉴</strong>에서 표를 편집하거나 표의 서식을 만듭니다.</p>",
  "fabric.help.center.tableManipulation.title": "표 조작",
  "fabric.help.center.templates.details": "<p>요구 조건에 부합하는 템플릿을 찾아보세요. 패널이 닫혀 있으면 추가 작업(•••) 메뉴에서 패널을 다시 엽니다.</p>",
  "fabric.help.center.templates.title": "템플릿",
  "fabric.help.center.title": "기본 사항 알아보기",
  "fabric.insert.external.image": "웹에서 이미지 삽입",
  "fabric.template.can.not.parse.content": "이 템플릿은 끊어진 또는 지원되지 않는 요소를 포함하고 있으므로 열 수 없습니다.",
  "fabric.template.can.not.save.error.title": "변경사항을 저장할 수 없음",
  "fabric.template.can.not.save.error.title.duplicate": " <strong>{0}</strong>(이)라는 템플릿이 이미 있습니다. 저장하려면 템플릿에 다른 제목을 지정하세요.",
  "fabric.template.found.invalid.node": "이름이 \"{variableNames}\"(으)로 같지만 파라미터가 다른 템플릿 변수가 여러 개 있습니다.",
  "favourite.spaces": "내 스페이스",
  "feedback.flag.thanks.description": "귀하의 피드백은 당사가 더 나은 경험을 구축하는 데 도움이 됩니다.",
  "feedback.flag.thanks.title": "감사합니다!",
  "filter.name": "필터",
  "gif.file": "GIF 파일",
  "global.spaces": "사이트 스페이스",
  "globaladminbilling.label": "결제",
  "header.or.footer.unsupported.macros.list": "다음 매크로는 현재 {0}에서 지원되지 않습니다:",
  "header.or.footer.unsupported.macros.title": "지원되지 않는 매크로",
  "heading.comment": "변경한 사람",
  "heading.createpage": "페이지 만들기",
  "heading.createpage.sentence": "페이지 만들기",
  "heading.operations": "동작",
  "heading.version.date": "발행됨",
  "heading.version.number": "버전",
  "help.name": "도움말",
  "help.us.improve": "제품 개선에 도움을 주세요",
  "hipchat.presence.status.available": "이용 가능",
  "hipchat.presence.status.away": "멀리 떨어짐",
  "hipchat.presence.status.dnd": "방해 금지",
  "hipchat.presence.status.offline": "오프라인",
  "html.file": "HTML 파일",
  "icon.tooltip.remove": "제거",
  "icon.tooltip.undo": "실행 취소",
  "image.browser.imageurl.label": "이미지 URL",
  "image.height": "높이",
  "image.properties.dialog.cancel": "취소",
  "image.properties.dialog.heading": "그림 속성",
  "image.properties.trigger": "속성",
  "image.properties.trigger.tooltip": "추가 그림 속성 보기",
  "inline.comment.sidebar.navigate.next.description": "다음 인라인 댓글",
  "inline.comment.sidebar.navigate.previous.description": "이전 인라인 댓글",
  "inline.comments.GROW-1507.dialog.close.label": "닫기",
  "inline.comments.GROW-1507.dialog.content": "인라인 댓글에 관해 알고 계십니까?<br>댓글을 검토하고 문서의 특정 부분에 이를 추가할 때 활용할 수 있습니다.",
  "inline.comments.GROW-1507.dialog.header": "인라인 댓글",
  "inline.comments.GROW-1507.dialog.ok.label": "알겠습니다.",
  "inline.comments.GROW-1507.dialog.showme.label": "보기",
  "inline.comments.GROW-1507.dialog.title": "댓글 팁",
  "inline.comments.batch.email.view": "댓글 보기",
  "inline.comments.create.placeholder": "댓글 작성...",
  "inline.comments.create.reply.placeholder": "회신",
  "inline.comments.date.friendly.about.one.hour.ago": "1시간 전",
  "inline.comments.date.friendly.about.x.days.ago": "{0}일 전",
  "inline.comments.date.friendly.about.x.hours.ago": "{0}시간 전",
  "inline.comments.date.friendly.formatted": "{0}",
  "inline.comments.date.friendly.now": "지금",
  "inline.comments.date.friendly.one.min.ago": "1분 전",
  "inline.comments.date.friendly.x.mins.ago": "{0, plural, other {{0}분 전}}",
  "inline.comments.date.friendly.yesterday": "어제",
  "inline.comments.delete.confirmation.message": "댓글을 삭제하시겠습니까?",
  "inline.comments.delete.permission": "이 댓글을 삭제할 권한이 없습니다.",
  "inline.comments.delete.reply.confirmation.message": "이 회신을 삭제하시겠습니까?",
  "inline.comments.delete.with.reply": "회신이 있는 인라인 댓글 스레드는 삭제할 수 없습니다.",
  "inline.comments.delete.with.reply.need.reload": "이 스레드에 새 회신이 있기 때문에 이 댓글을 삭제할 수 없습니다. 보려면 다시 로드하십시오.",
  "inline.comments.edit.permission": "이 댓글을 편집할 권한이 없습니다.",
  "inline.comments.editor.lost": "댓글이 지워집니다.",
  "inline.comments.editor.timeout": "편집기가 정상적으로 로드하지 않았습니다. {0}페이지를 새로 고쳐{1} 다시 시도하십시오.",
  "inline.comments.expand.replies": "회신 {0}개 추가",
  "inline.comments.fabric.editor.error.cannot.be.empty": "댓글이 비어 있습니다. 피드백을 추가한 다음 저장을 클릭하세요.",
  "inline.comments.fabric.editor.error.captcha.check.failed": "Captcha 확인 실패",
  "inline.comments.fabric.editor.error.captcha.check.succeeded": "Captcha 확인 성공",
  "inline.comments.fabric.editor.error.create.not.permitted": "권한 설정으로 인해 댓글을 작성할 수 없습니다. 이 기능이 필요한 경우 관리자에게 문의하세요.",
  "inline.comments.fabric.editor.error.delete.not.permitted": "권한 설정으로 인해 댓글을 삭제할 수 없습니다. 이 기능이 필요한 경우 관리자에게 문의하세요.",
  "inline.comments.fabric.editor.error.edit.not.permitted": "권한 설정으로 인해 댓글을 편집할 수 없습니다. 이 기능이 필요한 경우 관리자에게 문의하세요.",
  "inline.comments.fabric.editor.error.invalid.selection": "댓글을 만들 수 없습니다. 댓글이 적절한 콘텐츠에 매핑되도록 선택 사항을 더 분명하게 하려면 더 독특한 텍스트에 강조 표시를 만드세요.",
  "inline.comments.fabric.editor.error.resolve.not.permitted": "권한 설정으로 인해 댓글 문제를 해결할 수 없습니다. 이 기능이 필요한 경우 관리자에게 문의하세요.",
  "inline.comments.fabric.editor.error.unexpected": "이 댓글을 저장하는 중에 문제가 발생했습니다. 댓글을 닫거나 페이지를 새로 고친 후 댓글 추가를 다시 시도해 보세요.",
  "inline.comments.fabric.editor.error.view.not.permitted": "권한 설정으로 인해 댓글을 볼 수 없습니다. 이 기능이 필요한 경우 관리자에게 문의하세요.",
  "inline.comments.fabric.inline.button.cancel": "취소",
  "inline.comments.fabric.inline.button.save": "저장",
  "inline.comments.fabric.sidebar.loading.error": "오류가 발생했습니다. 댓글 창을 닫고 다시 시도하세요.",
  "inline.comments.likes.error": "좋아요를 업데이트할 수 없습니다.",
  "inline.comments.likes.like": "좋아요",
  "inline.comments.likes.unlike": "싫어요",
  "inline.comments.navigation.index.of": "{0}/{1}",
  "inline.comments.notification.email.reopened": "다시 열림",
  "inline.comments.notification.email.resolved": "해결됨",
  "inline.comments.notification.email.view": "댓글 보기",
  "inline.comments.resolve.permission": "이 댓글을 해결할 권한이 없습니다.",
  "inline.comments.resolved.dangling.message": "{0} {1}이(가) 텍스트를 삭제했기 때문에 해결됨",
  "inline.comments.resolved.dialog.empty": "이 페이지에는 해결된 댓글이 없습니다.",
  "inline.comments.resolved.dialog.message": "이 댓글은 영원히 사라지지 않습니다! 언제든지 해결된 댓글을 볼 수 있습니다.",
  "inline.comments.resolved.dialog.show.me": "보기",
  "inline.comments.resolved.discovery.button.dismiss": "알겠습니다.",
  "inline.comments.resolved.discovery.content": "더 하실 말씀이 있습니까? 해결된 댓글을 다시 열어서 논의를 계속할 수 있습니다.",
  "inline.comments.resolved.menu.show.replies": "회신 {0}개",
  "inline.comments.resolved.menu.show.reply": "{0} 회신",
  "inline.comments.resolved.menu.unresolve": "다시 열기",
  "inline.comments.resolved.message": "{0} {1}이(가) 해결함",
  "inline.comments.resolved.view.menu": "댓글을 해결함",
  "inline.comments.server.edit.error": "편집한 내용을 저장할 수 없습니다. 댓글이 삭제되었을 수도 있습니다.",
  "inline.comments.server.error": "요청을 완료할 수 없습니다.",
  "inline.comments.server.error.edit.comment": "이 댓글을 편집할 수 없습니다. 댓글이 삭제되었을 수도 있습니다.",
  "inline.comments.server.error.edit.reply": "이 회신을 편집할 수 없습니다. 회신이 삭제되었을 수도 있습니다.",
  "inline.comments.sidebar.cancel": "취소",
  "inline.comments.sidebar.close": "닫기",
  "inline.comments.sidebar.comment.empty": "빈 댓글은 저장할 수 없습니다.",
  "inline.comments.sidebar.delete": "삭제",
  "inline.comments.sidebar.deleted": "삭제됨",
  "inline.comments.sidebar.discard": "버리기",
  "inline.comments.sidebar.edit": "편집",
  "inline.comments.sidebar.error.create.comment": "\\인라인 댓글을 추가할 수 없습니다. 강조 표시한 섹션에 매크로나 사용자 멘션이 있을 수 있습니다. 일반 텍스트를 강조 표시해 보십시오.",
  "inline.comments.sidebar.error.delete.generic": "댓글을 삭제하는 도중 오류 발생. 자세한 오류는 Confluence 로그를 확인하십시오.",
  "inline.comments.sidebar.error.delete.unauthorised": "이 댓글을 삭제할 충분한 권한이 없습니다.",
  "inline.comments.sidebar.error.empty": "댓글을 입력하십시오.",
  "inline.comments.sidebar.error.save.comment": "댓글을 저장할 수 없습니다",
  "inline.comments.sidebar.error.save.reply": "회신을 저장할 수 없습니다",
  "inline.comments.sidebar.error.stale": "페이지 내용이 오래 되었습니다. {0}새로 고친{1} 후 다시 시도하십시오.",
  "inline.comments.sidebar.like": "좋아요",
  "inline.comments.sidebar.pagecomment.success": "페이지 댓글이 성공적으로 생성되었습니다",
  "inline.comments.sidebar.reply": "회신",
  "inline.comments.sidebar.resolve": "해결",
  "inline.comments.sidebar.resolved": "해결됨",
  "inline.comments.sidebar.save": "저장",
  "inline.comments.sidebar.saved": "저장됨",
  "inline.comments.sidebar.shortcuts.close.description": "인라인 댓글 닫기",
  "inline.comments.sidebar.show.resolved.comment": "해결된 댓글 표시",
  "inline.comments.sidebar.tooltip.close.description": "사이드 바 닫기(])",
  "inline.comments.sidebar.tooltip.next.ic.description": "다음 댓글(N)",
  "inline.comments.sidebar.tooltip.previous.ic.description": "이전 댓글(P)",
  "inline.comments.templates.create.a.comment": "페이지에 <strong>댓글을 작성함</strong>",
  "inline.comments.templates.resolved.a.comment": "댓글을 <strong>해결함</strong>",
  "inline.comments.templates.resolved.a.comment.dangling": "인라인 댓글에서 참조하는 텍스트가 삭제되었기 때문에 댓글이 <strong>해결</strong>되었습니다.",
  "inline.comments.templates.unresolved.a.comment": "댓글을 <strong>다시 열었음</strong>",
  "inline.comments.unresolved.message": "{0} {1}이(가) 다시 열음",
  "jar.file": "Java 어카이브",
  "java.file": "Java 원본",
  "jpeg.file": "JPEG 파일",
  "js.file": "JavaScript 파일",
  "keyboard.shortcut.alt": "Alt",
  "keyboard.shortcut.ctrl": "Ctrl키",
  "keyboard.shortcut.option": "선택사항",
  "keyboard.shortcut.shift": "시프트키",
  "label.contains.invalid.chars": "<b>{0}</b> 유효하지 않은 문자를 포함하고 있습니다 ({1}).",
  "label.name.is.too.long": "레이블 이름은 {0} 글자 이내여야 합니다.",
  "labels.dialog.shortcut.tip": "바로 가기 팁: 페이지 보기에서 <b>{shortcut}</b>를 눌러도 이 대화상자가 열립니다",
  "labels.none": "레이블 없음",
  "labels.title": "레이블",
  "last.saved": "마지막 저장",
  "likes.bethefirst": "처음으로 좋아하는 사람이 돼볼까요?",
  "likes.follow": "팔로우",
  "likes.following": "따르는 중",
  "likes.like": "좋아요",
  "likes.peoplewholikethis": "좋아하는 사람들",
  "likes.summary.1.non-promoted": "{0}님이 좋아합니다",
  "likes.summary.1.promoted": "{0}님이 좋아합니다",
  "likes.summary.1.promoted.1.non-promoted": "{0}님과 {1}님이 이것을 좋아합니다",
  "likes.summary.2.promoted": "{0}님과 {1}님이 이것을 좋아합니다",
  "likes.summary.2.promoted.1.non-promoted": "{0}, {1}, {2} 님들이 이것을 좋아합니다",
  "likes.summary.3.promoted": "{0}, {1}, {2} 님들이 이것을 좋아합니다",
  "likes.summary.3.promoted.1.non-promoted": "{0}, {1}, {2}, {3} 님들이 좋아합니다",
  "likes.summary.you": "내가 좋아합니다",
  "likes.summary.you.1.non-promoted": "나랑 {0}님이 좋아합니다",
  "likes.summary.you.1.promoted": "나랑 {0}님이 좋아합니다",
  "likes.summary.you.1.promoted.1.non-promoted": "나랑, {0}, {1}님이 좋아합니다",
  "likes.summary.you.2.promoted": "나랑, {0}, {1}님이 좋아합니다",
  "likes.summary.you.2.promoted.1.non-promoted": "나랑, {0}, {1}, {2}님이 좋아합니다",
  "likes.summary.you.3.promoted": "나랑, {0}, {1}, {2}님이 좋아합니다",
  "likes.summary.you.3.promoted.1.non-promoted": "나랑, {0}, {1}, {2}, {3}님이 좋아합니다",
  "likes.unlike": "좋아요 취소",
  "limited.mode.existing.editor.body": "공동 작업이 현재 오프라인 상태이며, {0}(이)가 이 페이지를 편집하고 있습니다. 몇 분 뒤 다시 시도하세요.",
  "link.browser.advanced.desc1": "새 페이지로의 연결을 삽입하려면, 원하는 페이지 제목을 입력하세요.",
  "link.browser.advanced.desc2": "책갈피 연결을 삽입하려면, #책갈피이름 을 입력하세요.",
  "link.browser.advanced.error.internal.error": "내부 서버 오류가 발생했습니다.",
  "link.browser.advanced.error.not.link": "제공된 마크업이 유효한 연결 마크업이 아닙니다.",
  "link.browser.advanced.error.unknown.shortcut": "{0} 바로가기를 인식할 수 없습니다.",
  "link.browser.advanced.error.unknown.space": "{0}은(는) 인식할 수 있는 스페이스가 아닙니다",
  "link.browser.advanced.title": "이때 <a href=\"{0}\" target=\"_blank\">위키 마크업</a>을 사용하여 페이지에 연결을 삽입할 수 있습니다.",
  "link.browser.autocomplete.hint": "참고: 편집창에서 \"[\"키를 누르면 추천 페이지의 목록이 나타나고 연결을 삽입할 수 있습니다.",
  "link.browser.cancel.button": "취소",
  "link.browser.edit.button": "삽입",
  "link.browser.edit.title": "연결 편집",
  "link.browser.file.attach": "파일 업로드",
  "link.browser.file.attach.desc": "이 페이지에 첨부되어 있거나 새로 파일을 첨부하고 연결하기.",
  "link.browser.file.attach.upload.in.progress": "업로드 진행 중...",
  "link.browser.file.browse.button": "찾기",
  "link.browser.files.none": "이 페이지에 파일이 없습니다.",
  "link.browser.insert.button": "삽입",
  "link.browser.insert.title": "연결 삽입",
  "link.browser.link": "연결",
  "link.browser.link.alias": "연결 문구",
  "link.browser.link.image.label": "그림 연결",
  "link.browser.location": "위치 연결",
  "link.browser.recently.viewed.load.error": "최근에 본 페이지를 불러오는 중 오류가 발생했습니다",
  "link.browser.recently.viewed.none": "최근에 본 것이 없습니다.",
  "link.browser.search": "검색",
  "link.browser.search.for": "다음을 검색",
  "link.browser.search.invalid": "올바르지 않은 검색 조건",
  "link.browser.search.results.load.error": "검색 도중 오류가 발생했습니다",
  "link.browser.search.results.none": "검색 결과 없음.",
  "link.browser.space.all": "모든 내용",
  "link.browser.tab.name.advanced": "고급",
  "link.browser.tab.name.files": "파일",
  "link.browser.tab.name.recently.viewed": "최근에 본",
  "link.browser.tab.name.search": "검색",
  "link.browser.tab.name.weblinks": "웹 연결",
  "link.browser.table.file.comment": "댓글",
  "link.browser.table.file.name": "이름",
  "link.browser.table.file.size": "크기",
  "link.browser.table.last.modified": "최근 수정",
  "link.browser.table.space": "스페이스",
  "link.browser.table.title": "제목",
  "link.browser.web.link": "URL",
  "link.browser.web.link.desc": "웹, 이메일 혹은 기타 인터넷 주소",
  "link.browser.web.link.label": "주소",
  "location.name": "위치",
  "login.button": "로그인",
  "look.and.feel": "모양새",
  "marketplace.link.name": "Marketplace 앱",
  "more.word.action": "추가 작업",
  "more.word.capitalised": "더 많은",
  "moveblogpost.already.exists.in.target.space": "선택된 스페이스에 같은 제목과 날짜의 다른 블로그 게시물이 있습니다.",
  "moveblogpost.source.notfound": "원본 블로그 게시물을 찾을 수 없습니다.",
  "moveblogpost.target.space.notfound": "대상 스페이스를 찾을 수 없습니다.",
  "moveblogpost.target.space.same.as.origin": "블로그 게시물을 이미 그 블로그 게시물이 있는 스페이스로 이동할 수 없습니다.",
  "multimedia.file": "멀티미디어 파일",
  "my.drafts.mainBanner": "아이디어를 빠르게 포착",
  "my.drafts.subBanner": "페이지를 만들어 아이디어를 적어보세요. 아직 게시할 준비가 되지 않았으면 페이지를 닫으면 됩니다. 작성한 내용은 초안으로 자동 저장되므로 나중에 준비되었을 때 이어서 작성할 수 있습니다. ",
  "my.spaces.tooltip.add": "내 스페이스에 추가",
  "my.spaces.tooltip.remove": "내 스페이스에서 제거",
  "name.word": "이름",
  "nav.controller.activity": "활동",
  "nav.controller.activity.feed": "활동 피드",
  "nav.controller.all.spaces": "스페이스",
  "nav.controller.discover": "발견",
  "nav.controller.my.spaces": "내 스페이스",
  "nav.controller.my.spaces.anchor": "모두",
  "nav.controller.my.spaces.blank": "가장 유용한 스페이스를 쉽게 액세스합니다. 스페이스 옆의 별 아이콘을 클릭하면 이곳에 나타납니다.",
  "nav.controller.my.spaces.blank.callToAction": "스페이스 찾기",
  "nav.controller.projects": "프로젝트",
  "nav.controller.recent": "최근 페이지",
  "nav.controller.your.work": "귀하의 작업",
  "navigation.app.switcher.apps": "앱",
  "navigation.app.switcher.dont.show.again": "다시 표시하지 않음",
  "navigation.app.switcher.edit": "편집",
  "navigation.app.switcher.error-message": "애플리케이션 링크를 가져오는 중에 오류 발생.",
  "navigation.app.switcher.home.description": "홈",
  "navigation.app.switcher.img.alt": "애플리케이션 전환기",
  "navigation.app.switcher.loading": "로드 중...",
  "navigation.app.switcher.recent": "최근",
  "navigation.app.switcher.recent-containers-confluence-space": "스페이스",
  "navigation.app.switcher.recent-containers-jira-project": "프로젝트",
  "navigation.app.switcher.try.other.apps": "다른 앱 시도하기",
  "navigation.app.switcher.use.confluence": "Confluence 사용하기",
  "navigation.app.switcher.use.jira": "Jira 사용하기",
  "navigation.label-for-bell": "알림",
  "navigation.label-for-global-people-icon": "사람 디렉토리",
  "navigation.notification-drawer-title": "홈 알림",
  "navigation.people-drawer-title": "사람 디렉토리",
  "navlink.edit": "편집({0}e{1})",
  "network.page": "네트워크 페이지",
  "no.drafts.found": "임시본이 없습니다.",
  "no.matches.mainBanner": "해당 사항을 찾을 수 없습니다.",
  "no.name": "아니요",
  "no.permission": "권한 없음",
  "no.spaces.found": "스페이스를 찾을 수 없습니다.",
  "not.watching.anything": "아무것도 지켜보고 있지 않습니다.",
  "notification.start": "지켜보기 시작",
  "notification.stop": "지켜보기 중단",
  "notifications.batch.inline.comment.created.section.header": "{0, choice, 1#인라인 댓글|1<인라인 댓글}",
  "notifications.batch.inline.comment.new.lozenge": "새로운",
  "notifications.batch.inline.comment.reopened.lozenge": "다시 시작했습니다",
  "notifications.batch.inline.comment.resolved": "$user 님이 댓글을 $lozenge",
  "notifications.batch.inline.comment.resolved.lozenge": "해결했습니다",
  "notifications.preferences.desc": "<a href=\"viewmyemailsettings.action\">이메일 설정</a> 페이지에서 이메일 알림 옵션을 설정할 수 있습니다.",
  "onboarding-choose-a-space.description": "팀의 현재 스페이스 중 하나를 선택하세요. 나중에 더 많은 스페이스를 만들 수 있습니다.",
  "onboarding-choose-a-space.title": "작업할 스페이스 선택",
  "onboarding.choose-a-space.backBtn": "뒤로",
  "onboarding.choose-a-space.nextBtn": "다음",
  "onboarding.choose-a-space.selectLabel": "스페이스 이름",
  "onboarding.choose-a-space.selectPlaceholder": "스페이스 이름 선택",
  "onboarding.create-a-space.backBtn": "뒤로",
  "onboarding.create-a-space.description": "현재 팀 또는 프로젝트를 위한 스페이스를 시작합니다. 나중에 추가로 스페이스를 만들 수 있습니다.",
  "onboarding.create-a-space.inputTextLabel": "이름",
  "onboarding.create-a-space.inputTextPlaceholder": "크리스탈 젬",
  "onboarding.create-a-space.invalidMessage": "스페이스 이름에는 최소 하나의 문자 또는 숫자가 필요합니다.",
  "onboarding.create-a-space.nextBtn": "다음",
  "onboarding.create-a-space.title": "작업할 스페이스 만들기",
  "onboarding.dialog.existing-user.cancel": "안내문 표시 안함",
  "onboarding.dialog.existing-user.confirm": "시작합시다.",
  "onboarding.dialog.existing-user.content": "더 나은 대시보드 경험을 위해 몇가지를 변경했습니다. 또한, 익숙해지는 것을 돕기 위해 안내문이 표시되도록 설정했습니다.",
  "onboarding.dialog.existing-user.title": "새 대시보드에 오신 것을 환영합니다!",
  "onboarding.dialog.new-user.cancel": "안내문 표시 안함",
  "onboarding.dialog.new-user.confirm": "시작합시다.",
  "onboarding.dialog.new-user.content": "대시보드는 컨플루언스를 잘 사용할 수 있도록 돕는 첫 시작 페이지입니다.<br/>익숙해지도록 일부 안내문이 표시되도록 설정했습니다.",
  "onboarding.dialog.new-user.title": "대시보드에 오신 것을 환영합니다!",
  "onboarding.navigation.blog.tip.blog.list.byline": "페이지들의 목록 또는 기타 컨텐츠로 전환하시려면 홈을 누르세요.",
  "onboarding.navigation.blog.tip.blog.list.heading": "당신의 블로그 목록은 여전히 이곳에서 찾으실 수 있습니다",
  "onboarding.navigation.dont.show": "더 이상의 팁을 보지 않겠습니다",
  "onboarding.navigation.global.sidebar.byline": "따라서 Confluence의 어느 위치에 있더라도 중요한 것들은 한 번의 클릭만으로 접근이 가능합니다.",
  "onboarding.navigation.global.sidebar.heading": "이 사이드바는 이제 보편적으로 적용됩니다",
  "onboarding.navigation.ok": "네, 알겠습니다",
  "onboarding.navigation.page.tip.page.tree.byline": "블로그들의 목록 또는 기타 컨텐츠로 전환하시려면 홈을 누르세요.",
  "onboarding.navigation.page.tip.page.tree.heading": "당신의 페이지 트리는 여전히 이곳에서 찾으실 수 있습니다",
  "onboarding.navigation.space.tip.space.tabs.byline": "스페이스 홈페이지는 이제 개요이며 페이지, 블로그 게시물 및 기타 콘텐츠에는 각각 탭이 있습니다.",
  "onboarding.navigation.space.tip.space.tabs.heading": "사용자의 콘텐츠가 이제 탭으로 구성되었습니다",
  "onboarding.tooltip.actions.done": "알겠습니다!",
  "onboarding.tooltip.actions.next": "다음",
  "onboarding.tooltip.actions.skip": "안내 건너뛰기",
  "onboarding.tooltip.existing-user.favourite-spaces.content": "즐겨찾는 스페이스로 바로 이동하거나 전체 스페이스 목록을 방문합니다.",
  "onboarding.tooltip.existing-user.favourite-spaces.title": "쉽게 즐겨찾기 스페이스 공간에 액세스",
  "onboarding.tooltip.existing-user.sidebar.content": "새 사이드바를 통해 새 페이지를 찾거나 최근에 작업하던 페이지로 돌아갈 수 있습니다.",
  "onboarding.tooltip.existing-user.sidebar.title": "사이드바에 대해 더 알아보기",
  "onboarding.tooltip.new-user.favourite-spaces.content": "즐겨찾는 스페이스로 바로 이동하거나 전체 스페이스 목록을 방문합니다.",
  "onboarding.tooltip.new-user.favourite-spaces.title": "쉽게 즐겨찾기 스페이스 공간에 액세스",
  "onboarding.tooltip.new-user.sidebar.content": "사이드바를 통해 새 페이지를 찾거나 최근에 작업하던 페이지로 돌아갈 수 있습니다.",
  "onboarding.tooltip.new-user.sidebar.title": "사이드바에 대해 더 알아보기",
  "onboarding.tooltip.saved-for-later.content": "가장 인기 있는 페이지가 이제 새 이름으로 표시됩니다. 나중을 위해 저장.",
  "onboarding.tooltip.saved-for-later.title": "즐겨찾기는 이제 그만두고 나중을 위해 저장을 시작하십시오.",
  "onboarding.who-is-on-your-team.addMoreBtn": "+ 이메일 더 추가",
  "onboarding.who-is-on-your-team.description": "Confluence는 팀원이 귀하와 함께하는 작업을 생성, 토론, 협력할 때 더욱 유용합니다.",
  "onboarding.who-is-on-your-team.emailPlaceholder": "이메일 주소 추가",
  "onboarding.who-is-on-your-team.enableDRS": "인증된 {domain} 이메일 주소를 가진 사람은 누구나 사이트에 가입할 수 있습니다(가입이 발생할 때마다 알림을 보냄).",
  "onboarding.who-is-on-your-team.enableOpenInvite": "사용자가 다른 사람을 귀하의 사이트로 초대하도록 하십시오.",
  "onboarding.who-is-on-your-team.form.invalid.email": "유효한 이메일 주소를 입력하십시오.",
  "onboarding.who-is-on-your-team.nextBtn": "다음",
  "onboarding.who-is-on-your-team.title": "팀 구성원",
  "only.personal.labels.permitted": "현재 사용자만 이 페이지에 개인 레이블을 추가할 수 있습니다.",
  "org.randombits.confluence.toc.toc.label": "목차",
  "page.already.exists": "같은 제목의 다른 페이지가 이미 선택한 스페이스에 있습니다.",
  "page.already.exists.inspace": "페이지 '{'0'}'은(는) 스페이스 '{'1'}'에 이미 있습니다. 이동하려면 페이지 제목의 이름을 바꿔야 합니다.",
  "page.change": "무엇을 변경했습니까?",
  "page.comments.saved.dialog.message": "댓글이 페이지 내용으로 저장되었습니다.",
  "page.comments.sidebar.warning": "이 내용에 인라인 댓글을 추가할 수 없습니다. 대신에 페이지 댓글로 추가됩니다.",
  "page.descendent.already.exists": "하위 페이지가 선택한 스페이스의 다른 페이지의 제목을 공유합니다.",
  "page.permissions.menu.item.title": "제한",
  "page.permissions.menu.item.title.tooltip": "제한 편집",
  "page.tree.blankExperience.mainBanner": "잠재력이 이곳의 전부입니다.",
  "page.tree.blankExperience.subBanner": "미팅 메모, 제품 요구 사항, 설명 문서 또는 기타 콘텐츠를 만들어서 이 스페이스를 채우세요.",
  "page.watch.instruction": "페이지나 블로그 게시물을 지켜보려면 : ‘도구’ 메뉴에서 ‘지켜보기’를 클릭하십시오.",
  "page.watches": "페이지 지켜보기",
  "page.word": "페이지",
  "pages.navigation.discovery.body.html": "<strong>페이지</strong>를 클릭하여 페이지 트리를 확인하고 스페이스에서 페이지을 탐색하세요.",
  "pages.navigation.discovery.header": "이제 페이지 트리가 여기에 나타납니다",
  "pages.show.all": "모든 페이지 보기",
  "pages.word": "페이지",
  "pagetree.dragndrop.failed.action.visitsupport": "Atlassian 지원 방문",
  "pagetree.dragndrop.failed.description": "페이지를 새로고침하고 다시 시도하세요. 계속 발생하는 경우 아래의 링크를 통해 알려주시기 바랍니다.",
  "pagetree.dragndrop.failed.title": "문제가 발생했습니다.",
  "pagetree.failed.load.content": "페이지 트리 로드 실패",
  "pagetree.failed.load.tooltip": "해당 내용 수정 중입니다.",
  "parent.page.invalid.for.space": "스페이스 <b>{1}</b>에 제목이 <b>{0}</b>인 페이지를 찾을 수 없습니다.",
  "parent.page.name": "상위 페이지",
  "pdf.file": "PDF 파일",
  "people.directory.name": "사용자 검색",
  "period.lastSevenDays": "지난 주",
  "period.lastThirtyDays": "지난 달",
  "period.older": "한달 이상 이전",
  "period.today": "오늘",
  "period.yesterday": "어제",
  "permission.owner.not.in.group": "사용자가 구성원으로 속해 있는 그룹에만 페이지 권한을 허용할 수 있습니다.",
  "permission.owner.not.set": "권한의 소유자를 선택해야합니다.",
  "permissions.comment": "페이지에 대한 조회와 편집 권한이 있는 사용자를 정의합니다. 당신 또는 사용자 그룹으로 제한할 수 있습니다.",
  "permissions.edit.title": "편집",
  "permissions.select.nopermissions": "설정되지 않음",
  "permissions.view.title": "보기",
  "person.follow": "따르기",
  "person.follow.stop": "그만 따르기",
  "personal.spaces": "개인 스페이스",
  "placeholder.placeholdertext.label": "문구 자리매김",
  "placeholder.replacementtext.label": "대체 문구",
  "please.enter.a.label": "레이블을 입력하세요.",
  "png.file": "PNG 파일",
  "popular.stream.mainBanner": "특이 사항은 없습니다... 아직",
  "popular.stream.subBanner": "지금은 크게 두드러지지 않으나, 팀이 생성 작업을 시작하면 가장 인기 있는 페이지와 파일이 여기에 나타날 것입니다.",
  "popular.stream.subBanner2": "이러한 작업을 시작해 보겠습니다!",
  "popular.stream.title": "잘 알려진",
  "posted.word": "게시됨",
  "powerpoint.file": "마이크로소프트 파워포인트 프레젠테이션",
  "powerpoint.macro.file": "마이크로소프트 파워포인트 매크로 사용 문서",
  "powerpoint.slideshow.file": "마이크로소프트 파워포인트 슬라이드쇼",
  "powerpoint.template.file": "마이크로소프트 파워포인트 양식",
  "powerpoint97.file": "마이크로소프트 파워포인트 97 슬라이드쇼",
  "powerpoint97.template.file": "마이크로소프트 파워포인트 97 양식",
  "product.name": "컨플루언스",
  "profile.page": "프로파일 페이지",
  "property.panel.macro.display.inline": "그 줄에 표시",
  "property.panel.macro.display.newline": "새 줄에 표시",
  "property.panel.macro.edit": "편집",
  "property.panel.macro.remove": "제거",
  "property.panel.textplaceholder.display.default": "텍스트",
  "property.panel.textplaceholder.display.default.tooltip": "사람 유형인 경우 설명 문구는 빈 칸이 됩니다.",
  "property.panel.textplaceholder.display.mention": "사용자 멘션",
  "property.panel.textplaceholder.display.mention.tooltip": "사람 유형인 경우 설명 문구가 추천 인물로 변경됩니다.",
  "property.panel.textplaceholder.remove": "삭제",
  "property.panel.variable.display.list": "목록",
  "property.panel.variable.display.list.tooltip": "드롭다운 목록.",
  "property.panel.variable.display.string": "텍스트",
  "property.panel.variable.display.string.tooltip": "한 줄 텍스트 입력 필드.",
  "property.panel.variable.display.textarea": "여러 줄 텍스트",
  "property.panel.variable.display.textarea.tooltip": "여러 줄 텍스트 입력 필드.",
  "property.panel.variable.list.values.tooltip": "목록의 각 항목을 쉼표(,)로 구분하여 입력",
  "property.panel.variable.textarea.columns.tooltip": "필드에 표시할 열의 수.",
  "property.panel.variable.textarea.rows.tooltip": "필드에 표시할 행의 수.",
  "quick.comment.placeholder.message": "댓글 쓰기...",
  "quick.reload.edit": "새 페이지 편집",
  "quick.reload.edit.by": "-",
  "quick.reload.edit.more": "그리고 {0} 다른 사람",
  "quick.reload.edit.one.more": "그리고 1명 더",
  "quick.reload.edits": "{0} 새 수정 사항",
  "quick.reload.newcomments": "{0} 새 댓글",
  "quick.reload.newpagecomment": "새 댓글",
  "quick.reload.reload": "페이지 새로고침",
  "recently-updated-content-list.commented.new": "{time}에 댓글 추가",
  "recently-updated-content-list.created.new": "{time}에 만듦",
  "recently-updated-content-list.edited.new": "{time}에 업데이트",
  "recently.viewed.mainBanner": "역사적 일을 수행할 때입니다.",
  "recently.viewed.subBanner": "아직 페이지를 방문하지 않았으나, 신속하게 되돌아올 수 있도록 여기에 드롭합니다.",
  "recently.viewed.subBanner2": "지금 <b>스페이스</b>으로 이동하여 둘러보세요.",
  "recently.viewed.title": "최근에 방문한",
  "recently.worked.mainBanner": "공들인 작업을 마무리하십시오",
  "recently.worked.subBanner": "아직 아무것도 생성하거나 편집하지 않았으나, 이를 수행할 때 마지막으로 읽은 위치를 쉽게 찾을 수 있도록 여기에 드롭합니다.",
  "recently.worked.subBanner2": "이제, 사용자의 뛰어난 작업으로 이동하여 생성합니다.",
  "recently.worked.title": "최근에 작업",
  "remove.comment.confirmation.message": "이 댓글을 삭제하시겠습니까?",
  "remove.label": "레이블 삭제",
  "resize.image.dialog.title": "이미지 크기 조정",
  "restore.this.version": "복원",
  "result.grid.column.content.last.modified": "최근 변경",
  "resume.editing": "계속 편집",
  "return.to.page.info": "페이지 정보로 돌아가기",
  "satisfaction.survey.reaction.amazing": "굉장하다",
  "satisfaction.survey.reaction.bad": "나쁘다",
  "satisfaction.survey.reaction.great": "아주 좋다",
  "satisfaction.survey.reaction.okay": "괜찮다",
  "satisfaction.survey.reaction.terrible": "끔찍하다",
  "save.name": "저장",
  "scheme.desc.custom": "편집할 수 있는 사용자 정의 색상 구성표.",
  "scheme.desc.global": "이 색상 구성표는 이 스페이스에 대해 전역으로 정의된 색상 구성표를 사용합니다.",
  "scheme.title.custom": "사용자 정의 색상 계획",
  "scheme.title.global": "전역 색상 계획",
  "search.drawer.recently.viewed": "최근에 조회",
  "search.drawer.recently.viewed.spaces": "최근 스페이스",
  "search.name": "검색",
  "settings.name": "환경설정",
  "share.button.restriction.message.text": "이 페이지의 제한 사항으로 인해 다른 사람이 보거나 편집하지 못할 수 있습니다.",
  "share.button.text": "공유",
  "show.more.blogposts": "블로그 게시물 더 보기",
  "sidebar.avatar.picker.upload.error": "스페이스 세부 정보를 업데이트하는 동안 오류가 발생했습니다.",
  "sidebar.main.back.to.overview": "개요로 돌아가기",
  "sidebar.main.back.to.space": "스페이스로 돌아가기",
  "sidebar.main.blog": "블로그",
  "sidebar.main.quick.links": "스페이스 바로 가기",
  "sidebar.main.settings": "스페이스 설정",
  "sidebar.main.shortcuts": "링크",
  "sidebar.main.wiki": "페이지",
  "site-settings.templates-and-blueprints.edit-button-label": "편집",
  "space.404.banner.title": "작동하지 않는 링크를 발견했습니다",
  "space.404.go.back": "다음으로 돌아가기",
  "space.404.go.to": "다음으로 이동",
  "space.404.home.page": "홈 페이지",
  "space.404.previous.page": "이전 페이지",
  "space.create": "스페이스 만들기",
  "space.home.blog.blankExperience.mainBanner": "공유할 다른 것이 있나요?",
  "space.home.blog.blankExperience.subBanner": "블로그 포스트는 팀에 관련된 공지, 현황 보고 및 중요 소식을 공유하기에 훌륭한 방법입니다.",
  "space.home.overview.blankExperience.mainBanner": "이건 조금 이상하군요.",
  "space.home.overview.blankExperience.subBanner": "이 스페이스에 홈 페이지가 없어 여기에 표시할 것이 없습니다. 죄송합니다.",
  "space.home.overview.blankExperience.subBanner2": "홈 페이지를 추가해 단장하고, 이를 이용해 방문자에게 해당 스페이스에 대해 소개하세요!",
  "space.not.exists": "지정한 스페이스가 없습니다.",
  "space.personal.name": "개인 스페이스",
  "space.set.space.home": "스페이스 홈 설정",
  "space.watch.instruction": "스페이스의 페이지 또는 블로그를 관찰하려면 스페이스 사이드바에서 ‘페이지’ 또는 ‘블로그’를 클릭하세요.",
  "space.watches": "스페이스 관찰하기",
  "spaces.all": "모든 스페이스",
  "spaces.lookandfeel.help": "여기서 Confluence 스페이스의 디자인을 사용자 지정할 수 있습니다.",
  "spaces.lookandfeel.note": "<span class=\"errorMessage\">참고:</span> <i>여기에서 변경한 모든 사항은 관리자가 설정한 기본 색상 계획과 기본 꾸밈보다 우선하게 됩니다.</i>",
  "spaces.word": "스페이스",
  "starred.mainBanner": "여기에 표시할 사항이 없습니다... 아직",
  "starred.spaces.tooltip.add": "이 스페이스에 별표 표시",
  "starred.spaces.tooltip.remove": "이 스페이스에서 별표 제거",
  "starred.subBanner": "나중을 위해 페이지를 저장하려면 <b>별 모양 아이콘</b>을 누르세요. 필요할 때 찾을 수 있도록 여기에 저장합니다.",
  "starred.title": "나중을 위해 저장",
  "status.lozenge.draft": "초안",
  "status.lozenge.unpublished": "게시되지 않은 변경 사항",
  "submit.name": "저장",
  "super-admin.banner.exit": "관리자 키 사용 중지",
  "super-admin.banner.message": "관리자 키를 사용하고 있습니다. 이 키를 이용하여 제한된 콘텐츠에 임시로 액세스할 수 있습니다.",
  "switch.apps": "앱 전환",
  "system.help.legal": "법률",
  "team.create.flag.error.description": "팀을 생성할 수 없습니다. 잠시 후 다시 시도하세요.",
  "team.create.flag.error.title": "죄송합니다. 문제가 발생했습니다.",
  "team.created.flag.description": "{membersCount, plural, other {'{'teamName'}' 팀에 {membersCount}명을 초대했습니다}}",
  "team.created.flag.title": "새 팀 생성됨",
  "team.created.flag.view": "팀 보기",
  "template.variables.fabric.section.message": "이 템플릿은 변수를 사용합니다. 변수를 채워 넣으면 입력한 정보가 새 페이지에서 내용의 일부가 됩니다.",
  "templates.name": "템플릿",
  "text.file": "텍스트 파일",
  "text.selected": "선택됨",
  "tinymce.advanced.block": "형식",
  "tinymce.advanced.blockquote": "인용",
  "tinymce.advanced.blockquote_shortcut": "Ctrl+8",
  "tinymce.advanced.bold_desc": "강조",
  "tinymce.advanced.bold_shortcut": "Ctrl+B",
  "tinymce.advanced.bullist_desc": "단추형 목록",
  "tinymce.advanced.bullist_shortcut": "Ctrl+Shift+B",
  "tinymce.advanced.charmap_desc": "기호",
  "tinymce.advanced.forecolor_desc": "문자열 색상 선택",
  "tinymce.advanced.formatting_desc": "서식",
  "tinymce.advanced.h1": "제목 1",
  "tinymce.advanced.h1_shortcut": "Ctrl+1",
  "tinymce.advanced.h2": "제목 2",
  "tinymce.advanced.h2_shortcut": "Ctrl+2",
  "tinymce.advanced.h3": "제목 3",
  "tinymce.advanced.h3_shortcut": "Ctrl+3",
  "tinymce.advanced.h4": "제목 4",
  "tinymce.advanced.h4_shortcut": "Ctrl+4",
  "tinymce.advanced.h5": "제목 5",
  "tinymce.advanced.h5_shortcut": "Ctrl+5",
  "tinymce.advanced.h6": "제목 6",
  "tinymce.advanced.h6_shortcut": "Ctrl+6",
  "tinymce.advanced.headings": "제목 1에서 6",
  "tinymce.advanced.headings_shortcut": "Ctrl+1..6",
  "tinymce.advanced.hr_desc": "가로줄",
  "tinymce.advanced.indent_desc": "들여쓰기",
  "tinymce.advanced.italic_desc": "기울임",
  "tinymce.advanced.italic_shortcut": "Ctrl+I",
  "tinymce.advanced.justifycenter_desc": "가운데 정렬",
  "tinymce.advanced.justifyfull_desc": "전체 정렬",
  "tinymce.advanced.justifyleft_desc": "좌측 정렬",
  "tinymce.advanced.justifyright_desc": "우측 정렬",
  "tinymce.advanced.numlist_desc": "번호형 목록",
  "tinymce.advanced.numlist_shortcut": "Ctrl+Shift+N",
  "tinymce.advanced.outdent_desc": "내어쓰기",
  "tinymce.advanced.paragraph": "문단",
  "tinymce.advanced.paragraph_shortcut": "Ctrl+0",
  "tinymce.advanced.pre": "사전 정의 형식",
  "tinymce.advanced.pre_shortcut": "Ctrl+7",
  "tinymce.advanced.redo_desc": "다시 하기",
  "tinymce.advanced.redo_shortcut": "Ctrl+Y",
  "tinymce.advanced.striketrough_desc": "취소선",
  "tinymce.advanced.striketrough_shortcut": "Ctrl+Shift+S",
  "tinymce.advanced.sub_desc": "아랫첨자",
  "tinymce.advanced.sup_desc": "윗첨자",
  "tinymce.advanced.tasklist_desc": "작업 목록",
  "tinymce.advanced.tasklist_shortcut": "[ 하고 ]",
  "tinymce.advanced.underline_desc": "밑줄",
  "tinymce.advanced.underline_shortcut": "Ctrl+U",
  "tinymce.advanced.undo_desc": "실행 취소",
  "tinymce.advanced.undo_shortcut": "Ctrl+Z",
  "tinymce.advanced.unlink_desc": "연결 해제",
  "tinymce.atlassian.help": "도움말",
  "tinymce.atlassian.insert_menu": "삽입",
  "tinymce.atlassian.insert_menu.charmap_desc": "기호 삽입",
  "tinymce.atlassian.insert_menu.content_desc": "내용 삽입",
  "tinymce.atlassian.insert_menu.hr_desc": "수평선 삽입 (----)",
  "tinymce.atlassian.insert_menu.macro_desc": "매크로 삽입",
  "tinymce.atlassian.insert_menu.tooltip": "더 많은 내용 삽입",
  "tinymce.atlassian.monospace": "고정 폭",
  "tinymce.atlassian.monospace_desc": "고정 폭 글꼴로 텍스트를 형식 지정",
  "tinymce.atlassian.more_menu": "더 많은",
  "tinymce.atlassian.remove_formatting": "서식 지우기",
  "tinymce.atlassian.remove_formatting_desc": "선택된 문자열의 서식 제거",
  "tinymce.auiwindowmanager.cancel": "취소",
  "tinymce.auiwindowmanager.ok": "확인",
  "tinymce.autocomplete.web.resource.name": "컨플루언스 자동완성 웹 자료",
  "tinymce.autocomplete.web.resource.only.name": "종속성 없는 컨플루언스 자동완성 웹 자료",
  "tinymce.charmap.web.resource.name": "TinyMce 문자 표 웹 자료",
  "tinymce.charmap_dlg.title": "기호 삽입",
  "tinymce.colorpicker.color": "색상",
  "tinymce.colorpicker.more_colors": "더 많은 색상",
  "tinymce.colorpicker.picker_tab": "선택기",
  "tinymce.colorpicker.picker_title": "색상 선택기",
  "tinymce.colorpicker.title": "색상 선택",
  "tinymce.colorpicker.web.resource.name": "컨플루언스 색상 선택기 웹 자료",
  "tinymce.confluence.conf_emoji": "이모티콘",
  "tinymce.confluence.conf_emoticon": "이모티콘",
  "tinymce.confluence.conf_emoticon_desc": "이모티콘 삽입",
  "tinymce.confluence.conf_file": "파일과 그림",
  "tinymce.confluence.conf_file_desc": "파일과 그림 삽입",
  "tinymce.confluence.conf_file_shortcut": "Ctrl+M",
  "tinymce.confluence.conf_image": "그림",
  "tinymce.confluence.conf_image_desc": "그림 삽입",
  "tinymce.confluence.conf_image_shortcut": "Ctrl+M",
  "tinymce.confluence.conf_link": "연결",
  "tinymce.confluence.conf_link_desc": "연결 삽입",
  "tinymce.confluence.conf_link_shortcut": "Ctrl+K",
  "tinymce.confluence.conf_macro_browser": "매크로",
  "tinymce.confluence.conf_macro_browser_desc": "매크로 삽입",
  "tinymce.confluence.conf_macro_browser_shortcut": "Ctrl+Shift+A",
  "tinymce.confluence.conf_media": "그림/미디어",
  "tinymce.confluence.conf_other_macros_desc": "다른 매크로...",
  "tinymce.confluence.conf_shortcuts_help": "키보드 바로가기 도움말",
  "tinymce.confluence.conf_tasklist": "작업 목록",
  "tinymce.confluence.conf_tasklist_desc": "작업 목록 삽입",
  "tinymce.confluence.conf_tasklist_shortcut": "[ 하고 ]",
  "tinymce.confluence.conf_widget_desc": "위젯",
  "tinymce.confluence.conf_wikimarkup": "마크업",
  "tinymce.confluence.conf_wikimarkup.insert.label": "삽입",
  "tinymce.confluence.conf_wikimarkup_confluence_label": "컨플루언스 위키",
  "tinymce.confluence.conf_wikimarkup_conversion_errors": "위키 문법 변환 오류",
  "tinymce.confluence.conf_wikimarkup_desc": "문법 삽입",
  "tinymce.confluence.conf_wikimarkup_hint": "힌트: 편집창에서 위키 문법을 입력하면, 입력하는 대로 바로 자동 인식됩니다.",
  "tinymce.confluence.conf_wikimarkup_info_title": " 아래에 위키 마크업 또는 마크다운을 입력하십시오. 컨플루언스가 사용자의 컨텐트를 편집기 형식으로 변환하여 사용자의 페이지에 삽입합니다.",
  "tinymce.confluence.conf_wikimarkup_markdown_label": "마크다운",
  "tinymce.confluence.conf_wikimarkup_preview_label": "미리보기",
  "tinymce.confluence.conf_wikimarkup_shortcut": "Ctrl+Shift+D",
  "tinymce.confluence.conf_wikimarkup_timeout": "서버가 위키 문법을 변환하는데 너무 오래걸렸습니다. 일시적인 문제인 경우일 수 있으니 다시 시도해 주세요.",
  "tinymce.confluence.files": "파일",
  "tinymce.confluence.help_desc": "도움말",
  "tinymce.confluence.htmlsource": "원본",
  "tinymce.confluence.htmlsource_desc": "HTML 원본 보기",
  "tinymce.confluence.layout.menu": "페이지 배치",
  "tinymce.confluence.layout.none": "배치 없음",
  "tinymce.confluence.layout.three_col": "3단",
  "tinymce.confluence.layout.three_col_sidebars": "3단 (좌우 사이드바)",
  "tinymce.confluence.layout.three_col_simple": "3단 (단순)",
  "tinymce.confluence.layout.two_col": "2단",
  "tinymce.confluence.layout.two_col_left": "2단 (좌측 사이드바)",
  "tinymce.confluence.layout.two_col_right": "2단 (우측 사이드바)",
  "tinymce.confluence.layout.two_col_simple": "2단 (단순)",
  "tinymce.confluence.layout.two_col_simple_left": "2단 (간단한 좌측 사이드바)",
  "tinymce.confluence.layout.two_col_simple_right": "2단 (간단한 우측 사이드바)",
  "tinymce.confluence.macro_insert": "'{'0'}' 매크로 삽입",
  "tinymce.confluence.macro_other": "다른 매크로",
  "tinymce.confluence.macro_other_desc": "매크로 탐색기 열기",
  "tinymce.confluence.placeholder.inline.tasks": "이 곳에 작업을 입력하고 \"@\" 으로 사용자를 할당하고 \"//\"로 기한을 지정합니다.",
  "tinymce.confluence.preview": "미리보기",
  "tinymce.confluence.preview_shortcut": "Ctrl+Shift+E",
  "tinymce.confluence.save_shortcut": "Ctrl+S",
  "tinymce.confluence.settings_desc": "편집기 설정",
  "tinymce.confluence_dlg.insertbutton.title": "삽입",
  "tinymce.confluence_dlg.insertimage.title": "그림 삽입",
  "tinymce.confluence_dlg.insertlink.title": "연결 삽입",
  "tinymce.emotions.emotions_desc": "이모티콘",
  "tinymce.emotions.web.resource.name": "TinyMce 감정 웹 리소스",
  "tinymce.emotions_dlg.add": "더하기 (+)",
  "tinymce.emotions_dlg.biggrin": "함박 미소 :D",
  "tinymce.emotions_dlg.broken_heart": "찢어지는 가슴 </3",
  "tinymce.emotions_dlg.check": "확인 (/)",
  "tinymce.emotions_dlg.desc": "이모티콘",
  "tinymce.emotions_dlg.error": "오류 (x)",
  "tinymce.emotions_dlg.forbidden": "빼기 (-)",
  "tinymce.emotions_dlg.heart": "하트 <3",
  "tinymce.emotions_dlg.help_16": "물음표 (?)",
  "tinymce.emotions_dlg.information": "정보 (i)",
  "tinymce.emotions_dlg.lightbulb": "꺼진 전구 (off)",
  "tinymce.emotions_dlg.lightbulb_on": "켜진 전구 (on)",
  "tinymce.emotions_dlg.sad": "슬픈 :(",
  "tinymce.emotions_dlg.smile": "웃음 :)",
  "tinymce.emotions_dlg.star_blue": "파란별 (*b)",
  "tinymce.emotions_dlg.star_green": "녹색별 (*g)",
  "tinymce.emotions_dlg.star_red": "빨강별 (*r)",
  "tinymce.emotions_dlg.star_yellow": "노랑별 (*y)",
  "tinymce.emotions_dlg.thumbs_down": "엄지 아래로 (n)",
  "tinymce.emotions_dlg.thumbs_up": "엄지 위로 (y)",
  "tinymce.emotions_dlg.title": "이모티콘 삽입",
  "tinymce.emotions_dlg.tongue": "메롱 :p",
  "tinymce.emotions_dlg.warning": "경고 (!)",
  "tinymce.emotions_dlg.wink": "윙크 ;)",
  "tinymce.fabric.migration.dialog.action": "편집을 계속하십시오.",
  "tinymce.fabric.migration.dialog.content": "걱정마십시오. 변경 사항이 손실되지 않습니다. 페이지 업데이트만 되었을 뿐입니다.",
  "tinymce.fabric.migration.dialog.title": "편집 경험을 업데이트했습니다.",
  "tinymce.formatting.paragraph": "일반 텍스트",
  "tinymce.full_screen.toolbar_item": "전체 화면",
  "tinymce.full_screen.toolbar_item_title": "전체 화면으로 편집기 실행",
  "tinymce.hints.autoformat.code": "힌트: \"<strong>'{{'code'}}'</strong>\"을(를) 입력하여 고정 폭 텍스트를 빠르게 삽입합니다.",
  "tinymce.hints.autoformat.heading1": "힌트: \"<strong>h1. 제목</strong>\" 을 입력하면 바로 \"제목1\"의 형식으로 삽입할 수 있습니다.",
  "tinymce.hints.autoformat.heading3": "힌트: \"<strong>h3. 제목</strong>\" 을 입력하면 바로 \"제목3\"의 형식으로 삽입할 수 있습니다.",
  "tinymce.hints.dnd": "힌트: 사용자의 컴퓨터에서 끌어다 놓기로 이 편집창에 그림이나 오피스 파일을 바로 가져올 수 있습니다.",
  "tinymce.hints.drafts": "힌트: 컨플루언스는 자동으로 임시본을 저장합니다. 창을 실수로 닫거나, 문제가 발생한 경우, \"사용자이름 -> 임시본\" 메뉴에서 작업하던 문서를 복구할 수 있습니다.",
  "tinymce.hints.insert.bullet.list": "힌트: <strong>Ctrl+Shift+B</strong>를 사용하여 단추형 목록을 시작할 수 있습니다.",
  "tinymce.hints.insert.heading": "힌트: <strong>Ctrl+1</strong>을 누르면 제목 1단계를 생성하고, 제목 2단게는 <strong>Ctrl+2</strong> 이런 식으로 계속 됩니다.",
  "tinymce.hints.insert.image": "힌트: <strong>Ctrl+M</strong>을 누르면 그림 선택기가 열립니다.",
  "tinymce.hints.insert.image.end": "힌트: 단어 뒤에서 <strong>Ctrl+Shift+M</strong>을 누르면 관련 그림을 찾아 삽입합니다.",
  "tinymce.hints.insert.image.on.page": "힌트: \"<strong>!</strong>\"를 눌러 페이지에 첨부된 그림을 보고 삽입할 수 있습니다.",
  "tinymce.hints.insert.image.search": "힌트: \"<strong>!</strong>\"과 그림 파일 이름의 일부를 입력하여 그림을 검색하고 삽입할 수 있습니다.",
  "tinymce.hints.insert.link": "힌트: <strong>Ctrl+K</strong>를 눌러 연결 탐색기를 엽니다.",
  "tinymce.hints.insert.link.end": "힌트: 단어 뒤에서 <strong>Ctrl+Shift+K</strong> 를 눌러 관련 페이지를 검색하고 연결합니다. 한 번 더 누르면 더 많은 추천을 볼 수 있습니다.",
  "tinymce.hints.insert.link.newpage": "힌트: \"<strong>[</strong>\" 를 입력해서 추천 연결을 삽입하거나 생성하고자 하는 새 페이지의 제목을 입력합니다.",
  "tinymce.hints.insert.link.recently.viewed": "힌트: \"<strong>[</strong>\" 를 입력하여 추천 페이지의 목록을 보고, 연결을 삽입할 수 있습니다.",
  "tinymce.hints.insert.link.search": "힌트: \"<strong>[</strong>\" 와 제목의 일부를 입력하여 페이지를 찾고 해당 페이지로의 연결을 만들 수 있습니다.",
  "tinymce.hints.insert.link.user.mention": "힌트: Confluence에서 \"<strong>@</strong>\" 기호와 사용자 이름을 입력하여 해당 사용자를 멘션할 수 있습니다.",
  "tinymce.hints.insert.macro": "힌트: <strong>Ctrl+Shift+A</strong>를 눌러 매크로 탐색기를 열 수 있습니다.",
  "tinymce.hints.insert.macro.toc": "도움말: 컨플루언스가 이 페이지의 목차를 생성하도록 합니다. \"삽입 -> 목차\"를 사용하십시오.",
  "tinymce.hints.insert.newline": "힌트: <strong>Shift+Enter</strong> 를 입력하여 여백 없이 새 문단을 시작할 수 있습니다",
  "tinymce.hints.insert.numbered.list": "힌트: <strong>Ctrl+Shift+N</strong>을 눌러 번호형 목록을 시작할 수 있습니다.",
  "tinymce.hints.insert.table": "힌트: <strong>Ctrl+Shift+I</strong>를 눌러 표를 삽입할 수 있습니다.",
  "tinymce.hints.insert.wikimarkup": "힌트: 편집창에 위키 문법을 입력하면 입력하는 대로 바로 변환이 됩니다.",
  "tinymce.hints.insert.wikimarkup.dialog": "힌트: <strong>Ctrl+Shift+D</strong>를 눌러 위키 문법 대화상자를 엽니다.",
  "tinymce.hints.table.rows.copy": "힌트: 표에서 <strong>Ctrl+Shift+C</strong>로 행을 복사하고, <strong>Ctrl+Shift+V</strong>를 눌러 행을 붙여넣기 할 수 있습니다.",
  "tinymce.hints.table.rows.cut": "힌트: 표에서 <strong>Ctrl+Shift+X</strong>를 눌러 행을 잘라내고, <strong>Ctrl+Shift+V</strong>를 눌러 행을 붙여넣기 할 수 있습니다.",
  "tinymce.macro.preview.exception": "매크로 미리보기를 수행하는 동안 예외가 발생했습니다. 예외: {0}",
  "tinymce.macro.unknownMacro": "'{'0'}'은(는) 알려진 매크로가 아닙니다. 시스템에서 제거했을 수도 있습니다.",
  "tinymce.popup_blocked": "브라우져에서 편집기가 새 창을 띄우는 것을 막았습니다.",
  "tinymce.propertypanel.images.border": "테두리",
  "tinymce.propertypanel.images.border.tooltip": "그림 주변에 테두리 표시",
  "tinymce.propertypanel.images.large": "크게",
  "tinymce.propertypanel.images.large.tooltip": "그림 크기를 크게 조정하고 원본에 연결",
  "tinymce.propertypanel.images.link.create": "연결",
  "tinymce.propertypanel.images.link.create.tooltip": "이 그림을 다른 내용으로 연결",
  "tinymce.propertypanel.images.link.edit": "연결 편집",
  "tinymce.propertypanel.images.link.edit.tooltip": "이 그림의 연결 편집",
  "tinymce.propertypanel.images.link.remove": "연결 해제",
  "tinymce.propertypanel.images.link.remove.tooltip": "이 그림의 연결 제거",
  "tinymce.propertypanel.images.medium": "중간",
  "tinymce.propertypanel.images.medium.tooltip": "그림 크기를 중간으로 조정하고 원본에 연결",
  "tinymce.propertypanel.images.original": "원본",
  "tinymce.propertypanel.images.original.tooltip": "그림 크기를 원본 크기로",
  "tinymce.propertypanel.images.sizing.tooltip": "그림을 지정 넓이로 조정",
  "tinymce.propertypanel.images.small": "작게",
  "tinymce.propertypanel.images.small.tooltip": "그림 크기를 작게 조정하고 원본에 연결",
  "tinymce.propertypanel.links.edit": "편집",
  "tinymce.propertypanel.links.edit.tooltip": "대화창에서 연결 편집",
  "tinymce.propertypanel.links.goto": "연결로 이동",
  "tinymce.propertypanel.links.goto.disabled.tooltip": "이 연결은 사용자가 편집하고 있는 페이지의 내용으로 이동합니다.",
  "tinymce.propertypanel.links.unlink": "연결 해제",
  "tinymce.propertypanel.links.unlink.tooltip": "다음 문자열을 포함하는 연결을 대체",
  "tinymce.searchreplace.replace_desc": "찾기/바꾸기",
  "tinymce.searchreplace.search_desc": "찾기",
  "tinymce.searchreplace_dlg.allreplaced.plural": "{0} 개를 바꾸었습니다.",
  "tinymce.searchreplace_dlg.allreplaced.singular": "1 개를 바꾸었습니다.",
  "tinymce.searchreplace_dlg.close": "닫기",
  "tinymce.searchreplace_dlg.direction": "방향",
  "tinymce.searchreplace_dlg.down": "아래",
  "tinymce.searchreplace_dlg.findlabel": "찾기",
  "tinymce.searchreplace_dlg.findnext": "다음",
  "tinymce.searchreplace_dlg.findprevious": "이전",
  "tinymce.searchreplace_dlg.findwhat": "찾기",
  "tinymce.searchreplace_dlg.mcase": "대소문자 구분",
  "tinymce.searchreplace_dlg.notfound": "변경된 바꾸기가 없습니다",
  "tinymce.searchreplace_dlg.replace": "바꾸기",
  "tinymce.searchreplace_dlg.replace_title": "찾기/바꾸기",
  "tinymce.searchreplace_dlg.replaceall": "모두 바꾸기",
  "tinymce.searchreplace_dlg.replacelabel": "바꾸기",
  "tinymce.searchreplace_dlg.search_title": "찾기",
  "tinymce.searchreplace_dlg.searchnext_desc": "다시 찾기",
  "tinymce.searchreplace_dlg.up": "위로",
  "tinymce.style.show-eol-markers": "¶",
  "tinymce.style.show-eol-markers.title": "개행문자 보이기/숨기기",
  "tinymce.table": "표",
  "tinymce.table.cell": "칸",
  "tinymce.table.col": "열",
  "tinymce.table.col_after_desc": "뒤에 열 추가",
  "tinymce.table.col_after_desc_shortcut_mac": "Control+Option+→",
  "tinymce.table.col_after_desc_shortcut_win": "Alt+Shift+→",
  "tinymce.table.col_before_desc": "앞에 열 추가",
  "tinymce.table.col_before_desc_shortcut_mac": "Control+Option+←",
  "tinymce.table.col_before_desc_shortcut_win": "Alt+Shift+←",
  "tinymce.table.col_copy_desc": "표의 열 복사하기",
  "tinymce.table.col_cut_desc": "표의 열 잘라내기",
  "tinymce.table.col_highlight": "머릿열",
  "tinymce.table.col_paste_desc": "표의 열 붙여넣기",
  "tinymce.table.copy_row_desc": "표의 행 복사",
  "tinymce.table.copy_row_shortcut": "Ctrl+Shift+C",
  "tinymce.table.cut_row_desc": "표의 행 잘라내기",
  "tinymce.table.cut_row_shortcut": "Ctrl+Shift+X",
  "tinymce.table.del": "표 제거",
  "tinymce.table.delete_col_desc": "열 제거",
  "tinymce.table.delete_row_desc": "행 제거",
  "tinymce.table.desc": "표 삽입",
  "tinymce.table.fixed_width": "고정 폭",
  "tinymce.table.fixed_width_tooltip": "열의 경계를 끌어서 너비를 설정하세요. 이 표는 항상 귀하가 설정한 너비로 나타납니다.",
  "tinymce.table.highlight_colour": "강조 색상",
  "tinymce.table.merge_cells_desc": "표의 칸 병합",
  "tinymce.table.more.heading": "표 설정",
  "tinymce.table.numbering_column_desc": "번호 열 삽입하기",
  "tinymce.table.paste_row_after_desc": "뒤에 행 붙이기",
  "tinymce.table.paste_row_before_desc": "표의 행 붙이기",
  "tinymce.table.paste_row_before_shortcut": "Ctrl+Shift+V",
  "tinymce.table.responsive": "반응형",
  "tinymce.table.responsive_tooltip": "컨텐츠를 추가할수록 표의 열이 더 넓어집니다. 열의 경계를 끌어서 서로에게 적합하고 페이지에 적합한 너비를 설정하세요.",
  "tinymce.table.row": "행",
  "tinymce.table.row_after_desc": "뒤에 행 삽입",
  "tinymce.table.row_after_desc_shortcut_mac": "Control+Option+↓",
  "tinymce.table.row_after_desc_shortcut_win": "Alt+Shift+↓",
  "tinymce.table.row_after_shortcut": "Alt+↓",
  "tinymce.table.row_before_desc": "앞에 행 삽입",
  "tinymce.table.row_before_desc_shortcut_mac": "Control+Option+↑",
  "tinymce.table.row_before_desc_shortcut_win": "Alt+Shift+↑",
  "tinymce.table.row_before_shortcut": "Alt+↑",
  "tinymce.table.row_highlight": "머릿행",
  "tinymce.table.selection_highlight": "셀 색상 변경",
  "tinymce.table.split_cells_desc": "합쳐진 표의 칸을 분리",
  "tinymce.table_dlg.cols": "열",
  "tinymce.table_dlg.equal.width.columns": "등간격 열",
  "tinymce.table_dlg.fullwidth": "전체 넓이",
  "tinymce.table_dlg.heading": "첫번째 열이 머릿열",
  "tinymce.table_dlg.invalid_table_field": "열과 행은 모두 양의 숫자여야 합니다.",
  "tinymce.table_dlg.rows": "행",
  "tinymce.table_dlg.sizetofit": "내용에 맞게 조정",
  "tinymce.table_dlg.title": "표 삽입",
  "tinymce.table_dlg.width": "넓이",
  "tinymce.table_shortcut": "Ctrl+Shift+I",
  "tinymce.tablepicker.insert_table": "표",
  "tinymce.tablepicker.insert_table_title": "표 삽입",
  "tinymce.tablepicker.nested_table_unsupported": "중첩 테이블은 지원되지 않습니다",
  "tinymce.tablepicker.pickerbox.tooltip": "머릿열이 없는 표를 위해서는 시프트 키를 누른 채 클릭하세요.",
  "tinymce.templates.actions.defined": "이 페이지에 삽입할 항목.",
  "tinymce.templates.insert-template": "양식",
  "tinymce.templates.insert-template.tooltip": "이 페이지에 삽입할 양식 항목.",
  "tinymce.templates.placeholder": "안내 문구",
  "tinymce.templates.placeholder.add": "자리 매김",
  "tinymce.templates.placeholder.add.tooltip": "페이지에 문장이 들어갈 자리를 삽입.",
  "tinymce.templates.placeholder.tooltip": "사용자가 입력하면 사라지고, 페이지를 볼 때 나타나지 않습니다.",
  "tinymce.templates.variables.add": "새 변수",
  "tinymce.templates.variables.add.tooltip": "페이지에 사용자가 채워 넣을 새 양식 필드 추가.",
  "tinymce.templates.variables.defined": "이 페이지에 삽입할 변수들.",
  "tinymce.templates.variables.insert.tooltip": "템플릿 사용자가 작성하도록 페이지에 '{'0'}' 필드를 삽입하세요.",
  "tinymce.templates.variables.manage": "변수 관리",
  "tinymce.templates.variables.none": "정의된 변수 없음",
  "tinymce.templates.variables.none.tooltip": "생성된 변수가 없습니다.",
  "tinymce.tools.toolbar_item_hide": "도구 숨기기",
  "tinymce.tools.toolbar_item_hide_title": "도구막대 숨기기",
  "tinymce.tools.toolbar_item_show": "도구 보이기",
  "tinymce.tools.toolbar_item_show_title": "도구막대 보이기",
  "tinymce.web.css.resource.name": "컨플루언스 편집기 CSS 웹 리소스",
  "tinymce.web.js.resource.name": "컨플루언스 편집기 자바스크립트 웹 리소스",
  "tinymce.web.resource.name": "컨플루언스 편집기 웹 리소스",
  "title.add.blogpost": "블로그 추가",
  "title.add.page": "페이지 추가",
  "title.add.page.template": "템플릿 생성",
  "title.comment": "댓글",
  "title.dashboard": "대시보드",
  "title.edit.page.template": "템플릿 편집",
  "title.manage.groups": "그룹",
  "title.name": "제목",
  "type.allcontent": "모든 내용",
  "unknown.file": "파일",
  "unsaved.comment.lost": "사용자의 댓글이 없어집니다.",
  "unsaved.content.lost": "변경사항이 저장되지 않을 수 있습니다.",
  "unsaved.template.lost": "저장하지 않은 템플릿 변경 사항은 사라집니다.",
  "untitled.draft.title": "제목 없음",
  "upm.marketplace.section": "Atlassian 마켓플레이스",
  "usermanagement.label": "사용자 관리",
  "usermanagement.parent.label": "사이트 관리",
  "users.name": "사용자",
  "view-changes-dialog.close.dialog": "닫기",
  "view-changes-dialog.editor.quit-dialog.title.diff": "게시되지 않은 변경 사항",
  "view.change": "변경 보기",
  "view.profile": "프로파일 보기",
  "viewdrafts.page.desc": "페이지를 편집할 때 변경내용을 발행하지 마세요. 드래프트가 생성됩니다. <b>계속</b>을 눌러서 계속 편집하거나 변경내용을 발행하세요.",
  "welcome.message.edit": "유용한 연결이나 안내문을 이곳에서 공유합니다.",
  "welcome.message.edit.link": "사용자 지정",
  "word.file": "마이크로소프트 워드 문서",
  "word.template.file": "마이크로소프트 워드 양식",
  "word97.file": "마이크로소프트 워드 97 문서",
  "word97.template.file": "마이크로소프트 워드 97 양식",
  "xml.file": "XML 파일",
  "yes.name": "예",
  "your.profile.and.settings": "귀하의 프로필 및 설정",
  "zip.file": "ZIP 보관"
}